<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture  v-if="this.pagedata"><img class="responsive-image"
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                                                   />

                                </picture>


                               <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
<!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
<!--                   height="100%" autoplay loop>-->
<!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
<!--                Your browser does not support the video tag.-->
<!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
$i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle :$i18n.locale=='Русский'?pagedata.page_rutitle: pagedata.page_frtitle
                                        }}</h2>
                                        <br />

<h3 v-if="pagedata" :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle :$i18n.locale=='Русский'?pagedata.ru_subtitle: pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                                                       <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '"
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '"
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="pagedata.id==38" class="FrameWork__InnerPageStyled-v8gq48-0 fHTiUO" >
                <div class="style__Details-drs3na-1 kMaaBC" >
                    <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">

                        <div class="style__Details-drs3na-1 kMaaBC" style="padding-top: 65px;
padding-bottom: 55px;">
                            <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                                <div class="FrameWork__Row-v8gq48-2 VIUMD">

                                        <div style="text-align: center;
width: 100%;
font-style: italic;
margin: 0px auto;
max-width: 100%" v-html="$i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
" class="FrameWork__ColSm-v8gq48-3 dIoETn">

                                            <p :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-left:10%;margin-right:10%;text-align: justify' :'font-family: Comfortaa!important;margin-left:10%;margin-right:10%;text-align: justify'">
                                                {{
                                                    $i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
                                                }}
                                            </p>
                                        </div>
                                    </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section v-if="pagedata.id==28" class="FrameWork__InnerPageStyled-v8gq48-0 fHTiUO"  >
                <div class="style__Details-drs3na-1 kMaaBC">
                    <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" >

                        <div class="style__Details-drs3na-1 kMaaBC" style="padding-top: 65px;
padding-bottom: 55px;">
                            <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                                <div class="FrameWork__Row-v8gq48-2 VIUMD">
                                    <div class="style__HighLight-drs3na-3 iVEPAq" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                                        <div style="text-align: center;
width: 100%;
font-style: italic;
margin: 0px auto;
max-width: 100%" v-html="$i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch :$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
" class="FrameWork__ColSm-v8gq48-3 dIoETn">

                                            <p  :style="$i18n.locale == 'العربية' ? 'margin-left:10%;margin-right:10%;text-align: justify;font-family: Cairo,sans-serif !important;' :'margin-left:10%;margin-right:10%;text-align: justify;font-family: Comfortaa!important; '">                                                {{
                                                    $i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <!--                        <div class="FrameWork__Row-v8gq48-2 VIUMD">-->
                                <!--                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">-->
                                <!--                                <div class="style__ListWrap-drs3na-2 JMaKG">-->
                                <!--                                    <div class="style__AddressWrap-drs3na-4 hkgfiT">-->
                                <!--                                        <div class="style__AddressItemStyled-sc-17n6b0m-0 FCFMu"-->
                                <!--                                             v-for="contact  in contactdata" :key="contact.id">-->
                                <!--                                            <div-->
                                <!--                                                v-html="$i18n.locale == 'en' ? contact.adressen : $i18n.locale == 'العربية' ? contact.adressar : $i18n.locale == '中文' ? contact.adressch : contact.adressfr">-->
                                <!--                                                {{-->
                                <!--                                                    $i18n.locale == 'en' ? contact.adressen : $i18n.locale == 'العربية' ? contact.adressar : $i18n.locale == '中文' ? contact.adressch : contact.adressfr-->
                                <!--                                                }}-->
                                <!--                                            </div>-->

                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <!--                            </div>-->
                                <!--                        </div>-->
                            </div>
                        </div>
                        <div class="FrameWork__Row-v8gq48-2 VIUMD" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                                <div :style="$i18n.locale == 'العربية' ? 'right:0;font-family: Cairo,sans-serif !important;text-align: right;' :'font-family: Comfortaa!important;'" class="style__ListWrap-drs3na-2 JMaKG">

                                    <div>

                                        <form class="style__FormWrap-sc-1iaf0iy-2 jZQfFQ" v-on:submit.prevent="submitForm" >
                                            <div>
                                                <input :style="$i18n.locale == 'العربية' ? 'text-align: right;' :''" v-model="name" name="name" type="text" autocomplete="nope"
                                                        placeholder="Name" value=""><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Name' : $i18n.locale == 'العربية' ? 'الإسم' : $i18n.locale == '中文' ? '名字':$i18n.locale=='Русский'?'Имя' : 'Nom'
                                                }}
                                            </label>
                                                <!--                                                <div class="error-message">Please enter your name</div>-->
                                            </div>
                                            <div><input v-model="email" name="email" type="email" autocomplete="nope"
                                                        placeholder="Email" value=""><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Email' : $i18n.locale == 'العربية' ? 'البريد الإلكتروني' : $i18n.locale == '中文' ? '邮箱' :$i18n.locale=='Русский'?'Электронное письмо': 'Adresse email'
                                                }}
                                            </label></div>
                                            <div><input v-model="subject" name="subject" type="text" autocomplete="nope"
                                                        placeholder="Subject" value=""><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Subject' : $i18n.locale == 'العربية' ? 'موضوع' : $i18n.locale == '中文' ? '主题' :$i18n.locale=='Русский'?'Предмет': 'Sujet'
                                                }}

                                            </label></div>
                                            <div><textarea v-model="message" name="message" autocomplete="nope"
                                                           placeholder="Message"></textarea><label :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'">
                                                {{
                                                    $i18n.locale == 'en' ? 'Message' : $i18n.locale == 'العربية' ? 'الرسالة' : $i18n.locale == '中文' ? '信息':$i18n.locale=='Русский'?'Сообщение' : 'Message'
                                                }}
                                            </label></div>
<!--                                            <div class="recaptcha">-->
<!--                                                <div>-->
<!--                                                    <div style="width: 304px; height: 78px;">-->
<!--                                                        <div>-->
<!--                                                            <iframe-->
<!--                                                                src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LeMvsUZAAAAAM554vVgQ4iGCmF9MwNdvKmbgCr_&amp;co=aHR0cHM6Ly9tYXJrZXRlcXVpdHkuY29tOjQ0Mw..&amp;hl=en&amp;type=image&amp;v=qc5B-qjP0QEimFYUxcpWJy5B&amp;theme=light&amp;size=normal&amp;badge=bottomright&amp;cb=8w6d7q21t2qg"-->
<!--                                                                role="presentation" name="a-o0bfmgpolmg" scrolling="no"-->
<!--                                                                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"-->
<!--                                                                width="304" height="78" frameborder="0"></iframe>-->
<!--                                                        </div>-->
<!--                                                        <textarea id="g-recaptcha-response" name="g-recaptcha-response"-->
<!--                                                                  class="g-recaptcha-response"-->
<!--                                                                  style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea>-->
<!--                                                    </div>-->
<!--                                                    <iframe style="display: none;"></iframe>-->
<!--                                                </div>-->
<!--                                            </div>-->
                                            <button :style="$i18n.locale == 'العربية' ? 'right:0;' :'left:0'" type="submit" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span
                                                class="caption">
                                                {{
                                                    $i18n.locale == 'en' ? 'Submit Request' : $i18n.locale == 'العربية' ? 'قدم' : $i18n.locale == '中文' ? '提交':$i18n.locale=='Русский'?'Отправить запрос' : 'Envoyer votre demande'
                                                }}
                                                </span></button>
                                        </form>
                                        <br /> <br /> <br /> <br />

                                        <p align="center" style="color:green" v-if="emailnotify"> {{ emailnotify }}</p>
                                    </div>


                                    <div>
                                        <div class="style__AddressWrap-drs3na-4 hkgfiT" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'" >
                                            <div v-for="contact  in contactdata" :key="contact.id"
                                                 class="style__AddressItemStyled-sc-17n6b0m-0 FCFMu" :style="$i18n.locale == 'العربية' ? 'padding-right: 80px;' :'padding-left: 80px;'">
                                                <div
                                                    v-html="$i18n.locale == 'en' ? contact.adressen : $i18n.locale == 'العربية' ? contact.adressar : $i18n.locale == '中文' ? contact.adressch :$i18n.locale=='Русский'?contact.adressru: contact.adressfr">
                                                    <p> {{
                                                            $i18n.locale == 'en' ? contact.adressen : $i18n.locale == 'العربية' ? contact.adressar : $i18n.locale == '中文' ? contact.adressch :$i18n.locale=='Русский'?contact.adressru: contact.adressfr
                                                        }}
                                                    </p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="pagedata.id!=38" :style="pagedata.id==42 || pagedata.id==43?'background: rgb(244, 247, 248) none repeat scroll 0% 0%;':''"

                     :class="$i18n.locale=='العربية'?'FrameWork__InnerPageStyled-v8gq48-0 kVMyZl':'FrameWork__InnerPageStyled-v8gq48-0 fHTiUO'">

                <h2 style="padding-top:5%;text-transform: uppercase;font-size: 37px;
line-height: 39px;" v-if="pagedata.id==42" align="center">{{ currentdate }}   {{
                        $i18n.locale == 'en' ? dayname : $i18n.locale == 'العربية' ? daynamear : $i18n.locale == '中文' ? dayname : currency.dayname
                    }} </h2>
                <div v-if="pagenameroute=='Glossary'" class="row" style="padding-top: 65px;
padding-bottom: 55px;padding-right: 10%;padding-left: 10%;height:100%">
                    <div class=" col-md-12">
                        <iframe width="100%" height="5000px"
                                :src="$i18n.locale=='العربية'?'https://marketequityinc.com/learning/glossaries.php?lang=ar':'https://marketequityinc.com/learning/glossaries.php?lang=en' "
                                v-if="pagenameroute=='Glossary'"></iframe>
                    </div>
                </div>

                                <section v-if="pagedata.id==53" class="FrameWork__InnerPageStyled-v8gq48-0 fHTiUO">
                    <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                        <div class="style__FundingAreaStyled-wdbq14-0 bMLaEc">
                            <div class="FrameWork__Row-v8gq48-2 VIUMD">
                                <div class="style__ListingStyled-wdbq14-1 ifRyix">

                                    <div v-if="$i18n.locale == '中文'">
<!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/unionpay-2.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/unionpay-2.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                </div>
                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                 <div style="margin-top:0%!important;color:#ffffff!important;"><p style="color:#ffffff!important;">最低入金: 20$</p>
                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank"
                                                                         rel="noopener noreferrer">现在存款</a></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                       <!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/visa1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->
<!--        -->
                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/visa1.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                 <div style="margin-top:0%!important;color:#ffffff!important;">

                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>Deposit Fee : 3.5%  <br>
                                                    Minimum Amount : 100USD</p>
                                                      <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">Кредитные карты :3.5% <br>
                                                    Минимальная сумма: 100USD</p>


                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'"><br>USD<br>رسوم الإيداع :3.5%<br>

                                                         أدنى مبلغ : 100 الدولار الأمريكي
                                                         <br></p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">费用 : 3.5% 每笔<br>
                                                        最低金额 : 100USD</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                        Frais de dépôt : 3.5% <br>
                                                        Montant minimum  : 100USD</p>
                                                </div>
                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank" rel="noopener noreferrer">

                                                    {{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}
                                                    </a></div>
                                            </div>
                                        </div>
                                    </div>

                                      <div>
<!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/mastercard-1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/mastercard-1.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                <div style="margin-top:0%!important;color:#ffffff!important;">

                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>Deposit Fee : 3.5%  <br>
                                                        Minimum Amount : 100USD</p>
                                                        <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">USD<br>Deposit Fee : 3.5% <br>
                                                    Минимальная сумма: 100USD</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'"><br>USD<br>رسوم الإيداع :3.5%<br>

                                                        أدنى مبلغ : 100 الدولار الأمريكي
                                                        <br></p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">费用 : 3.5% 每笔<br>
                                                        最低金额 : 100USD</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                        Frais de dépôt : 3.5% par
                                                        transaction<br>
                                                        Montant minimum  : 100USD</p>
                                                </div>
                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank" rel="noopener noreferrer">

                                                    {{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}

                                                </a></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                   <!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/knet-1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->
                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/knet-1.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                 <div style="margin-top:20%!important;color:#ffffff!important;">

                                                    <p style="color:#ffffff!important;margin-top:-5%!important;line-height:3em!important;" v-if="$i18n.locale=='en'">Deposit Fee : 500 fils per
                                                        transaction<br>
                                                        Minimum Amount : 20 KWD</p>

                                                         <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">Deposit Fee : 500 fils per
                                                             transaction<br>
                                                    Минимальная сумма: 20 KWD</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'"><br> رسوم الإيداع : 500 فلس لكل
                                                        معاملة<br>

                                                        الحد الأدنى للمبلغ: 20 KWDا <br></p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">当地借记卡 : 500 fils 每笔</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                        Frais de dépôt : 500 fils par
                                                        transaction<br>Cartes de débit locales  : 500 fils
                                                        per transaction<br>
                                                        Montant minimum  : 20KWD</p>


                                                </div>
                                                <div style="" class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank" rel="noopener noreferrer">
                                                                          {{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}
                                                    </a></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                       <!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/sticpay-1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->
                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/sticpay-1.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                 <div style="margin-top:0%!important;color:#ffffff!important;"><p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>Deposit Fee : 3% <br>
                                                    Limit: 100USD</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">3% <br>
                                                    Лимит: 100USD</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'"><br>USD<br>رسوم الإيداع :3%<br>
                                                        </p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">费用 : 3% 每笔<br>
                                                        最低金额 : 100USD</p>
                                                    <p style="color:#ffffff!important;"  v-if="$i18n.locale == 'Français'">USD<br>
                                                        Frais de dépôt : 3% <br>
                                                        Limite : 100USD</p>

                                                </div>
                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank" rel="noopener noreferrer">
                                                                        {{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}
                                                    </a></div>
                                            </div>
                                        </div>

                                    </div>

                                    <div>
                                       <!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/cashu-1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->
<!--        -->

 <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/skrill-1.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                 <div style="margin-top:0%!important;color:#ffffff!important;">
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>
                                                        Deposit Fee: 4 to 5%<br>
                                                        Minimum Amount : 100 USD</p>
                                                         <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">USD<br>
                                                        Deposit Fee: 4 to 5%<br>
                                                        Minimum Amount : 100 USD</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'"><br>الدولار الأمريكي<br>
                                                        رسوم الإيداع :4 إلى 5%<br>
                                                        أدنى مبلغ : 100 الدولار الأمريكي</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">USD<br>
                                                        费用: 4%- 5%<br>
                                                        最低金额 : 100 USD</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                        Frais de dépôt : 4 à 5%<br>
                                                        Montant minimum : 100 USD</p>
                                                </div>
                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank" rel="noopener noreferrer">

                                                   {{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}
                                                    </a></div>
                                            </div>
                                        </div>

<!--                <div class="details_wrap">-->
<!--                    <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a-->
<!--                        href="https://portal.marketequityinc.com/login" target="_blank"-->
<!--                        rel="noopener noreferrer">-->


<!--                        <picture><img loading="lazy" width="270" height="110"-->
<!--                                      :src="publicurl+'fundingicons/cashu-1.png'" alt=""-->
<!--                                      style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                        </picture></a></h3>-->

<!--                        <div class="btn_wrap"><span> </span></div>-->
<!--                    </div>-->
<!--                    <div class="deposit">-->
<!--                        <div style="margin-top:30%!important;color:#ffffff!important;">-->
<!--                            <p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>-->
<!--                                Deposit Fee: 7%<br>-->
<!--                                Minimum Amount : 100 USD</p>-->

<!--                            <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">USD<br>-->
<!--                                Deposit Fee: 7%<br>-->
<!--                                Minimum Amount : 100 USD</p>-->


<!--                            <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'">الدولار الأمريكي<br>-->
<!--                                رسوم الإيداع: 7%<br>-->
<!--                                أدنى مبلغ : 100 دولار امريكي</p>-->
<!--                            <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">美元<br>-->
<!--                                费用: 7%<br>-->
<!--                                最低金额 : 100 美元</p>-->
<!--                            <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>-->
<!--                                Deposit Fee: 7%<br>-->
<!--                                Montant minimum  : 100 USD</p>-->


<!--                        </div>-->
<!--                        <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"-->
<!--                                                 target="_blank" rel="noopener noreferrer">-->

<!--                            {{-->
<!--                                $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'-->
<!--                            }}-->
<!--                        </a></div>-->
<!--                    </div>-->
<!--                </div>-->                                    </div>
                                                                        <div>
                                       <!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/neteller-1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->
                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/neteller-1.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                <div style="margin-top:0%!important;color:#ffffff!important;">
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>
                                                        Deposit Fee: 4 to 5%<br>
                                                        Minimum Amount : 100 USD</p>
                                                         <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">USD<br>
                                                        Deposit Fee: 4 to 5%<br>
                                                        Minimum Amount : 100 USD</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'"> <br>الدولار الأمريكي<br>
                                                        رسوم الإيداع: 4 إلى 5%<br>
                                                        أدنى مبلغ : 100 دولار امريكي</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">美元<br>
                                                        费用: 4%- 5%<br>
                                                        最低金额 : 100 美元</p>
                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                        Frais de dépôt : 4 à 5%<br>
                                                        Montant minimum : 100 USD</p>


                                                </div>
                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank" rel="noopener noreferrer">

                                                   {{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}
                                                </a></div>
                                            </div>
                                        </div>

                                    </div>
                                     <div>
                                         <div class="details_wrap">
                                             <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                 href="https://portal.marketequityinc.com/login" target="_blank"
                                                 rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                                                               :src="publicurl+'fundingicons/fasapay.png'" alt=""
                                                               style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                                 </picture></a></h3>

                                                 <div class="btn_wrap"><span> </span></div>
                                             </div>
                                             <div class="deposit">
                                                 <div style="margin-top:20%!important;color:#ffffff!important;">
                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale=='en'">USD<br>
                                                         Deposit Fee: 0.5%<br>
                                                         </p>
                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">USD<br>
                                                         Deposit Fee: 0.5%<br>
                                                         </p>


                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale=='العربية'">الدولار الأمريكي<br>
                                                         رسوم الإيداع:  إلى 0.5%                                                         <br>
                                                         </p>
                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale == '中文'">美元<br>
                                                         费用: 0.5%<br>
                                                       </p>
                                                     <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                         Frais de dépôt : 0.5%<br>
                                                         </p>


                                                 </div>
                                                 <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                          target="_blank" rel="noopener noreferrer">

                                                     {{
                                                         $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                     }}
                                                 </a></div>
                                             </div>
                                         </div>


                                         <!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/skrill-1.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->
<!--        -->

                                    </div>
<div v-if="$i18n.locale == 'en' || $i18n.locale =='العربية' ||  $i18n.locale=='Русский'|| $i18n.locale=='Français'">
<!--        <div class="style__ImWrap-wdbq14-2 iLpSQn">-->
<!--            <div class=" gatsby-image-wrapper"-->
<!--                 style="position: relative; overflow: hidden; display: inline-block; width: 270px; height: 110px;">-->
<!--                <picture><img loading="lazy" width="270" height="110"-->
<!--                              :src="publicurl+'fundingicons/unionpay-2.png'" alt=""-->
<!--                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
<!--                </picture>-->
<!--            </div>-->
<!--        </div>-->                                        <div class="details_wrap">
                                            <div class="thumbOverlay"><h3 style="margin-top: 32%!important;"><a
                                                href="https://portal.marketequityinc.com/login" target="_blank"
                                                rel="noopener noreferrer">


                                                 <picture><img loading="lazy" width="270" height="110"
                              :src="publicurl+'fundingicons/unionpay-2.png'" alt=""
                              style="position:relative!important;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
               </picture></a></h3>

                                                </div>
                                                <div class="btn_wrap"><span> </span></div>
                                            </div>
                                            <div class="deposit">
                                                 <div style="margin-top:10%!important;color:#ffffff!important;"><p v-if="$i18n.locale=='en'" style="color:#ffffff!important;">USD<br>Deposit Fee : 2%<br>Minimum Amount: 100USD</p>

                                                  <p style="color:#ffffff!important;" v-if="$i18n.locale=='Русский'">USD<br>Deposit Fee : 2%<br>
                                                    Минимальная сумма: 100USD</p>

                                                  <p style="color:#ffffff!important;" v-if="$i18n.locale == 'Français'">USD<br>
                                                      Frais de dépôt : 2% par
                                                      transaction<br>
                                                        Montant minimum  :100USD</p>


                                                    <p style="color:#ffffff!important;" v-if="$i18n.locale == 'العربية'"> رسوم الإيداع : 2% لكل
                                                        معاملة<br>
                                                         أدنى مبلغ  : 100$</p>


                                                <div class="btn_wrap"><a style="margin-top: 30%!important;" href="https://portal.marketequityinc.com/login"
                                                                         target="_blank"
                                                                         rel="noopener noreferrer">{{
                                                        $i18n.locale == 'en' ? 'Deposit Now' : $i18n.locale == 'العربية' ? 'إيداع الآن' : $i18n.locale == '中文' ? '现在存款' :$i18n.locale=='Русский'?'Пополните аккаунт сейчас сейчас': 'Déposer Maintenant'
                                                    }}</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div v-if="pagedata.id==64" class="row" style="padding-top: 65px;
padding-bottom: 55px;padding-right: 10%;padding-left: 10%;">

                    <div class=" col-md-12">
                        <div class="panel-group" id="accordionswap" role="tablist" aria-multiselectable="true"
                             :style="$i18n.locale=='العربية'?'direction:rtl':'direction:left'">
                            <div v-for="swapscategory in swapscat" v-bind:key="swapscategory.id"
                                 class="panel panel-default">
                                <div :style="$i18n.locale=='العربية'?'float:right;width:100%;text-align:right':''"
                                     class="panel-heading" role="tab" id="heading">
                                    <h4 class="panel-title">
                                        <a role="button" data-toggle="collapse" data-parent="#accordionswap"
                                           :href="'#collapse'+swapscategory.id"
                                           :aria-expanded="swapscategory.id==1?true:false"
                                           aria-controls="collapseOne">
                                            {{ swapscategory.title }}
                                        </a>
                                    </h4>
                                </div>
                                <div :id="'collapse'+swapscategory.id"
                                     :class="swapscategory.id==1?'panel-collapse in collapse show':'panel-collapse in collapse'"
                                     role="tabpanel" aria-labelledby="headingOne">
                                    <div class="table-responsive panel-body">
                                        <table class="table  table-hover">
                                            <thead>
                                            <tr>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Category</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Majors</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Type</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">3 Day Swaps</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">ME Long</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">ME Short</th>

                                            </tr>
                                            </thead>
                                            <tbody v-for="swapsratedata in swapsrate"
                                                   v-bind:key="swapsratedata.id">

                                            <tr v-if="swapscategory.id==swapsratedata.catid">

                                                <td>{{ swapscategory.title }}</td>
                                                <td>{{ swapsratedata.majors }}</td>
                                                <td>{{ swapsratedata.type }}</td>
                                                <td>{{ swapsratedata.threedayswaps }}</td>
                                                <td>{{ swapsratedata.melong }}</td>
                                                <td>{{ swapsratedata.meshort }}</td>

                                            </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                <div v-if="pagedata.id==32" class="row" style="padding-top: 65px;
padding-bottom: 55px;padding-right: 10%;padding-left: 10%;">

                    <div class=" col-md-12">
                        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true"
                             :style="$i18n.locale=='العربية'?'direction:rtl':'direction:left'">
                            <div v-for="contractcategory in contractcat" v-bind:key="contractcategory.id"
                                 class="panel panel-default">
                                <div :style="$i18n.locale=='العربية'?'float:right;width:100%;text-align:right':''"
                                     class="panel-heading" role="tab" id="headingOne">
                                    <h4 class="panel-title">
                                        <a role="button" data-toggle="collapse" data-parent="#accordion"
                                           :href="'#collapse'+contractcategory.id"
                                           :aria-expanded="contractcategory.id==1?true:false"
                                           aria-controls="collapseOne">
                                            {{ contractcategory.title }}
                                        </a>
                                    </h4>
                                </div>
                                <div :id="'collapse'+contractcategory.id"
                                     :class="contractcategory.id==1?'panel-collapse in collapse show':'panel-collapse in collapse'"
                                     role="tabpanel" aria-labelledby="headingOne">
                                    <div class="table-responsive panel-body">
                                        <table class="table  table-hover">
                                            <thead>
                                            <tr>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Category</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Instrument</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Description</th>
                                                <th v-if="contractcategory.id!=8  && contractcategory.id!=9" :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Spread in Pips</th>

                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Digits</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Tick Size</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col" >Contract Size</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Order Offset / Ticks</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Tick Value</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Margin Rate</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Margin Currency</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Min Volume</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Max Volume</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Step</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Trading Hours</th>
                                                <th :style="$i18n.locale=='العربية'?'text-align: right':'text-align: left'" scope="col">Exceptions</th>
                                            </tr>
                                            </thead>
                                            <tbody v-for="contractspecdetailsdata in contractspecdetails"
                                                   v-bind:key="contractspecdetailsdata.id">

                                            <tr v-if="contractcategory.id==contractspecdetailsdata.catid">

                                                <td>{{ contractcategory.title }}</td>
                                                <td>{{ contractspecdetailsdata.instrument }}</td>
                                                <td>{{ contractspecdetailsdata.description }}</td>
                                                <td v-if="contractcategory.id!=8  && contractcategory.id!=9">{{ contractspecdetailsdata.spread_in_pips }}</td>
                                                <td>{{ contractspecdetailsdata.digits }}</td>
                                                <td>{{ contractspecdetailsdata.ticksize }}</td>
                                                <td>{{ contractspecdetailsdata.contractsize }}</td>
                                                <td>{{ contractspecdetailsdata.order_ticks }}</td>
                                                <td>{{ contractspecdetailsdata.tick_value }}</td>
                                                <td>{{ contractspecdetailsdata.margin_rate }}</td>
                                                <td>{{ contractspecdetailsdata.margin_currency }}</td>
                                                <td>{{ contractspecdetailsdata.min_volume }}</td>
                                                <td>{{ contractspecdetailsdata.max_volume }}</td>
                                                <td>{{ contractspecdetailsdata.step }}</td>
                                                <td width="150px" v-html="contractspecdetailsdata.trading_hours">{{ contractspecdetailsdata.trading_hours }}</td>
                                                <td>{{ contractspecdetailsdata.exceptions }}</td>
                                            </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


                <div :style="pagedata.id==52 || pagedata.id==49 || pagedata.id==30?'max-width: 100%;padding-top:0px;':''" v-if="pagedata.layout!=3" class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo"
                     style="opacity:1!important">

                    <div class="FrameWork__ContentData-v8gq48-10 ZBsdR" :style="pagedata.id==52 || pagedata.id==30?'padding-top:0px;padding-right:0px;padding-left:0px;padding-bottom:0px!important':'padding-bottom:0px!important'">
                        <div class="FrameWork__Row-v8gq48-2 VIUMD"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                            <div style="padding-left:10%;padding-right:10%;padding-bottom:2%" v-html="$i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
" class="FrameWork__ColSm-v8gq48-3 dIoETn">


                              {{
                                    $i18n.locale == 'en' ? pagedata.pagecontenten : $i18n.locale == 'العربية' ? pagedata.pagecontentar : $i18n.locale == '中文' ? pagedata.pagecontentch:$i18n.locale=='Русский'?pagedata.pagecontentru : pagedata.pagecontentfr
                                }}

                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="pagedata.id==39" class="row" style="padding-top: 2%;
padding-bottom: 2%;padding-right: 2%;padding-left: 2%;">
                    <div class="container">
                        <div v-if="$i18n.locale=='العربية'" class="row">
                            <div style="padding: 0px 60px 10px 12px;" v-for="learningcoursesardata in learningcoursesar"
                                 v-bind:key="learningcoursesardata.id" class="col-sm-3">
                                <img :src="publicurl+'courses.png'"/>
                                <div
                                    style="text-align: center;color:#000000;padding-top:1%;padding-left:1%">
                                    <h3><a style="font-weight:bold;color:#000000"
                                           :href="'../ar/courses/'+learningcoursesardata.id"><strong>{{
                                            learningcoursesardata.titlear
                                        }}</strong></a></h3>
                                    <p><span style="font-family: Comfortaa!important; "> {{ learningcoursesardata.coursearcount }}</span>  الدروس</p>
                                </div>
                            </div>


                        </div>
                        <div   v-else class="row" style="padding-top: 0px;
padding-bottom: 2%;padding-right: 2%;padding-left: 2%;">
                            <div  style="padding: 10px 60px 10px 12px;text-align: center;"
                                 v-for="learningcoursesendata in learningcoursesen"
                                 v-bind:key="learningcoursesendata.id" class="col-sm-3">
                                <a  style="font-weight:bold;color:#ffffff"
                                   :href="'../en/courses/'+learningcoursesendata.id"><img
                                    :src="publicurl+'courses.png'"/>
                                    <div
                                        style="color:#000000;padding-top:1%;padding-left:1%">
                                        <h3><strong>{{ learningcoursesendata.titleen }}</strong></h3>
                                        <p>{{ learningcoursesendata.courseencount }} lessons</p>
                                    </div>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>


                <div align="center" v-if="pagedata.id==42 || pagedata.id==43" class="row" style="justify-content: center;margin-top: -5%;
padding-bottom: 2%;margin-left:5%;margin-right:5%;">
                    <div align="center"
                         class="react-reveal" v-for="articles  in articlesdata" :key="articles.id"
                         style="text-align:justify;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                        <div align="center" style="max-width: 100%; margin-bottom:50%;"
                             class="col-md-3 col-sm-6 col-xs-12">

                            <figure><img v-if="$i18n.locale == 'العربية' && articles.titlear"
                                         :src="serverurl+'/public/articlesbanners/'+articles.bgimage"/>
                                <img v-if=" articles.titleen && $i18n.locale != 'العربية'"
                                     :src="serverurl+'/public/articlesbanners/'+articles.bgimage"/>
                            </figure>

                            <div id="analysisarticle">
                                <div v-if="$i18n.locale == 'العربية' && articles.titlear"
                                     style="line-height: 22px;padding: 55px 0px 30px;text-align:center;background-color: #ffffff;">
                                    <h3 style="font-size: 19px;
    line-height: 21px;width: 290px;
"><a style="color: #000000;font-weight:600" :href="'/ar/tech/articles/'+articles.id+'/'+articles.title"> {{
                                            $i18n.locale == 'en' ? articles.titleen : $i18n.locale == 'العربية' ? articles.titlear : $i18n.locale == '中文' ? articles.titlech : articles.titlefr
                                        }}</a></h3>
                                    <p v-html=" $i18n.locale == 'en' ? articles.descriptionen : $i18n.locale == 'العربية' ? articles.descriptionar : $i18n.locale == '中文' ? articles.descriptionch : articles.descriptionfr" style="padding-top:22px;margin-left: -100px;margin-right: 12%;width:70%;word-wrap:break-word;color: #000000;font-size: 16px;
    line-height: 22px;
"><a v-html=" $i18n.locale == 'en' ? articles.descriptionen : $i18n.locale == 'العربية' ? articles.descriptionar : $i18n.locale == '中文' ? articles.descriptionch : articles.descriptionfr" style="color: #000000;" :href="'/ar/tech/articles/'+articles.id+'/'+articles.title"> {{
                                            $i18n.locale == 'en' ? articles.descriptionen : $i18n.locale == 'العربية' ? articles.descriptionar : $i18n.locale == '中文' ? articles.descriptionch : articles.descriptionfr
                                        }}</a></p></div>
                                <div v-if="articles.titleen && $i18n.locale != 'العربية'"
                                     style="line-height: 22px;padding: 55px 0px 30px;text-align:center;background-color: #ffffff;">
                                    <h3 style="font-size: 19px;
    line-height: 21px;width: 290px;
"><a style="color: #000000;font-weight:600" :href="'/en/tech/articles/'+articles.id+'/'+articles.title"> {{
                                            $i18n.locale == 'en' ? articles.titleen : $i18n.locale == 'العربية' ? articles.titlear : $i18n.locale == '中文' ? articles.titlech : articles.titlefr
                                        }}</a></h3>
                                    <p v-html="$i18n.locale == 'en' ? articles.descriptionen : $i18n.locale == 'العربية' ? articles.descriptionar : $i18n.locale == '中文' ? articles.descriptionch : articles.descriptionfr" style="padding-top:22px;margin-left: 10px;width:90%;word-wrap:break-word;color: #000000;font-size: 16px;
    line-height: 22px;
"><a v-html=" $i18n.locale == 'en' ? articles.descriptionen : $i18n.locale == 'العربية' ? articles.descriptionar : $i18n.locale == '中文' ? articles.descriptionch : articles.descriptionfr" style="color: #000000;" :href="'/en/tech/articles/'+articles.id+'/'+articles.title"> {{
                                            $i18n.locale == 'en' ? articles.descriptionen : $i18n.locale == 'العربية' ? articles.descriptionar : $i18n.locale == '中文' ? articles.descriptionch : articles.descriptionfr
                                        }}</a></p></div>


                            </div>
                        </div>

                    </div>

                    <div align="center"
                         class="react-reveal" v-for="currency  in currencydata" :key="currency.id"
                         style="text-align:justify;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                        <div align="center" style="
                        max-width: 100%; margin-bottom:50%;"
                             class="col-md-3 col-sm-6 col-xs-12">

                            <figure><img v-if="$i18n.locale == 'العربية' && currency.titlear"
                                         :src="serverurl+'/public/currencybanners/'+currency.bgimage"/>
                                <img v-if=" currency.titleen && $i18n.locale != 'العربية'"
                                     :src="serverurl+'/public/currencybanners/'+currency.bgimage"/>
                            </figure>

                            <div id="analysis">
                                <div v-if="$i18n.locale == 'العربية' && currency.titlear"
                                     style="line-height: 22px;padding: 55px 0px 30px;text-align:center;background-color: #ffffff;">
                                    <h3 style="font-size: 19px;
    line-height: 21px;
"><a style="color: #000000;font-weight:600" :href="'/ar/tech/currency/'+currency.id+'/'+currency.title"> {{
                                            $i18n.locale == 'en' ? currency.titleen : $i18n.locale == 'العربية' ? currency.titlear : $i18n.locale == '中文' ? currency.titlech : currency.titlefr
                                        }}</a></h3>
                                    <p style="padding-top:22px;margin-left: -100px;margin-right: 12%;width:70%;word-wrap:break-word;color: #000000;font-size: 16px;
    line-height: 22px;
"><a style="color: #000000;" :href="'/ar/tech/currency/'+currency.id+'/'+currency.title"> {{
                                            $i18n.locale == 'en' ? currency.descriptionen : $i18n.locale == 'العربية' ? currency.descriptionar : $i18n.locale == '中文' ? currency.descriptionch : currency.descriptionfr
                                        }}</a></p></div>
                                <div v-if="currency.titleen && $i18n.locale != 'العربية'"
                                     style="line-height: 22px;padding: 55px 0px 30px;text-align:center;background-color: #ffffff;">
                                    <h3 style="font-size: 19px;
    line-height: 21px;
"><a style="color: #000000;font-weight:600" :href="'/en/tech/currency/'+currency.id+'/'+currency.title"> {{
                                            $i18n.locale == 'en' ? currency.titleen : $i18n.locale == 'العربية' ? currency.titlear : $i18n.locale == '中文' ? currency.titlech : currency.titlefr
                                        }}</a></h3>
                                    <p style="padding-top:22px;margin-left: 10px;width:90%;word-wrap:break-word;color: #000000;font-size: 16px;
    line-height: 22px;
"><a style="color: #000000;" :href="'/en/tech/currency/'+currency.id+'/'+currency.title"> {{
                                            $i18n.locale == 'en' ? currency.descriptionen : $i18n.locale == 'العربية' ? currency.descriptionar : $i18n.locale == '中文' ? currency.descriptionch : currency.descriptionfr
                                        }}</a></p></div>


                            </div>
                        </div>

                    </div>

                    <div v-if="pagedata.id==42" class="col-md-12 col-sm-6 col-xs-12" style="margin-bottom: 2%"><h2 style="font-size: 37px;font-weight: 500;text-transform: capitalize;">{{ $i18n.locale == 'العربية'?'الكروس ':'Crosses'}}  {{ currentdate }}</h2></div>

                    <div align="center"
                         class="react-reveal" v-for="crosses  in crossesdata" :key="crosses.id"
                         style="text-align:justify;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                        <div align="center" style="max-width: 100%; margin-bottom:50%;"
                             class="col-md-3 col-sm-6 col-xs-12">

                            <figure><img v-if="$i18n.locale == 'العربية' && crosses.titlear"
                                         :src="serverurl+'/public/crossesbanners/'+crosses.bgimage"/>
                                <img v-if=" crosses.titleen && $i18n.locale != 'العربية'"
                                     :src="serverurl+'/public/crossesbanners/'+crosses.bgimage"/>
                            </figure>

                            <div id="analysiscrosses">
                                <div v-if="$i18n.locale == 'العربية' && crosses.titlear"
                                     style="line-height: 22px;padding: 55px 0px 30px;text-align:center;background-color: #ffffff;">
                                    <h3 style="font-size: 19px;
    line-height: 21px;
"><a style="color: #000000;font-weight:600" :href="'/ar/tech/crosses/'+crosses.id+'/'+crosses.title"> {{
                                            $i18n.locale == 'en' ? crosses.titleen : $i18n.locale == 'العربية' ? crosses.titlear : $i18n.locale == '中文' ? crosses.titlech : crosses.titlefr
                                        }}</a></h3>
                                    <p style="padding-top:22px;margin-left: -100px;margin-right: 12%;width:70%;word-wrap:break-word;color: #000000;font-size: 16px;
    line-height: 22px;
"><a v-html="$i18n.locale == 'en' ? crosses.descriptionen : $i18n.locale == 'العربية' ? crosses.descriptionar : $i18n.locale == '中文' ? crosses.descriptionch : crosses.descriptionfr" style="color: #000000;" :href="'/ar/tech/crosses/'+crosses.id+'/'+crosses.title"> {{
                                            $i18n.locale == 'en' ? crosses.descriptionen : $i18n.locale == 'العربية' ? crosses.descriptionar : $i18n.locale == '中文' ? crosses.descriptionch : crosses.descriptionfr
                                        }}</a></p></div>
                                <div v-if="crosses.titleen && $i18n.locale != 'العربية'"
                                     style="line-height: 22px;padding: 55px 0px 30px;text-align:center;background-color: #ffffff;">
                                    <h3 style="font-size: 19px;
    line-height: 21px;
"><a style="color: #000000;font-weight:600" :href="'/en/tech/crosses/'+crosses.id+'/'+crosses.title"> {{
                                            $i18n.locale == 'en' ? crosses.titleen : $i18n.locale == 'العربية' ? crosses.titlear : $i18n.locale == '中文' ? crosses.titlech : crosses.titlefr
                                        }}</a></h3>
                                    <p style="padding-top:22px;margin-left: 10px;width:90%;word-wrap:break-word;color: #000000;font-size: 16px;
    line-height: 22px;
"><a v-html="$i18n.locale == 'en' ? crosses.descriptionen : $i18n.locale == 'العربية' ? crosses.descriptionar : $i18n.locale == '中文' ? crosses.descriptionch : crosses.descriptionfr" style="color: #000000;" :href="'/en/tech/crosses/'+crosses.id+'/'+crosses.title"> {{
                                            $i18n.locale == 'en' ? crosses.descriptionen : $i18n.locale == 'العربية' ? crosses.descriptionar : $i18n.locale == '中文' ? crosses.descriptionch : crosses.descriptionfr
                                        }}</a></p></div>


                            </div>
                        </div>

                    </div>

                </div>



 <div v-if="pagedata.id==41" class="row" style="padding-top: 1%;
padding-bottom: 55px;padding-right: 10%;padding-left: 10%;">

                    <div v-for="faqcategory in faqcategories" v-bind:key="faqcategory.id" class=" col-md-12">
                        <p  :style="$i18n.locale=='العربية'?'font-size:22px!important;font-family: Cairo, sans-serif !important;':'font-size:22px!important;font-family: Comfortaa!important;'" ><b>
                            {{
                                $i18n.locale == 'en' ? faqcategory.faqcattitleen : $i18n.locale == 'العربية' ? faqcategory.faqcattitlear : $i18n.locale == '中文' ? faqcategory.faqcattitlech:$i18n.locale=='Русский'?faqcategory.faqcattitleru:faqcategory.faqcattitlefr
                            }}
                        </b>
                        </p>


                        <div class="panel-group" id="accordionfaq1" role="tablist" aria-multiselectable="true"  :style="$i18n.locale=='العربية'?'font-family: Cairo, sans-serif !important;float:right;width:100%;text-align:right;direction:rtl':''"
                             >
                            <div v-for="faqdata in faq" v-bind:key="faqdata.id"
                                 class="panel panel-default" style="border:0px!important">
                                <div v-if="faqdata.categoryid == faqcategory.id"
                                     class="panel-heading" role="tab" id="headingOnefaq" >
                                    <h4 class="panel-title">
                                        <a v-html="$i18n.locale == 'en' ? faqdata.questionen : $i18n.locale == 'العربية' ? faqdata.questionar : $i18n.locale == '中文' ? faqdata.questionch:$i18n.locale=='Русский'?faqdata.questionru : faqdata.questionfr"  role="button" data-toggle="collapse" data-parent="#accordionfaq1"
                                           :href="'#collapse'+faqdata.id"

                                           aria-controls="collapseOne"  :style="$i18n.locale=='العربية'?'font-family: Cairo, sans-serif !important;float:right;width:100%;text-align:right;direction:rtl':''">
                                            {{ $i18n.locale == 'en' ? faqdata.questionen  : $i18n.locale == 'العربية' ? faqdata.questionar : $i18n.locale == '中文' ? faqdata.questionch :$i18n.locale=='Русский'?faqdata.questionru: faqdata.questionfr }}
                                        </a>
                                    </h4>
                                </div>
                                <div v-if="faqdata.categoryid == faqcategory.id" :id="'collapse'+faqdata.id"  :style="$i18n.locale=='العربية'?'font-family: Cairo, sans-serif !important;padding-top: 1%;\n'+
'  padding-left: 1%;,padding-right: 1%;padding-bottom: 1%;font-size: 22px;line-height: 2;':'font-family: Comfortaa!important;padding-top: 1%;padding-left: 1%;padding-right: 1%;padding-bottom: 1%;font-size: 17px;line-height: 2;'"
                                     class="panel-collapse in collapse"
                                     role="tabpanel" aria-labelledby="headingOnefaq">
                                    <div :style="$i18n.locale=='العربية'?'font-family: Cairo, sans-serif !important;font-size: 22px!important;line-height:2':'font-family: Comfortaa!important;font-size: 22px!important;line-height:2'" v-html="$i18n.locale == 'en' ? faqdata.answeren : $i18n.locale == 'العربية' ? faqdata.answerar : $i18n.locale == '中文' ? faqdata.answerch : faqdata.answerfr">{{ faqdata.answeren }}</div>
                                </div>
                            </div>


                        </div>


                    </div>

                </div>
  <div v-if="pagedata.id==70" class="FrameWork__ColSm-v8gq48-3 dIoETn">


                    <div class="style__ListWrap-sc-12u8p00-2 ecvDnw" style="margin-left: 5%">
                        <div class="row">
                            <div class="col" id="first">
                                <div class="contentVertical">
                                    <form class="style__FormWrap-sc-1iaf0iy-2 jZQfFQ webinar-form-v2">
                                        <div></div>
                                        <div id="firstdiv">
                                            <input name="clientid" type="text" autocomplete="nope"
                                                   placeholder="Account Number" value="">
                                            <label :style="$i18n.locale=='العربية'?'float:right;margin-right: 10%;right:0':'float:left;left:0'">{{ $i18n.locale=='العربية'?'رقم حساب العميل':'Account Number' }}</label></div>
                                        <div></div>
                                         <div :style="$i18n.locale=='العربية'?'margin-right:10%':''"    id="buttons" class="style__GoButton-sc-1iaf0iy-5 jBuUVu">

                                        <button @click="checkaccount()" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs" style="color: #ffffff">{{ $i18n.locale=='العربية'?'إستمرار':'Go' }}</button>
<br />
                                        <a id="second" @click="showsecond()">
                                            {{ $i18n.locale=='العربية'?'ليس لدي حساب للتداول':'I do not have an account number' }}</a>

                                    </div>
                                        <div class="style__FormPreLoader-sc-1iaf0iy-4 hUWiwF"></div>
                                        <div id="seconddiv" class="style__HiddenFormField-sc-1iaf0iy-3 dYMUwu"
                                             style="display:none;">
                                            <div class="full-width"><h4>Please fill your details</h4></div>
                                            <div>
                                                <div><input name="name" type="text" autocomplete="nope"
                                                            placeholder="Name" value=""><label>Name</label></div>
                                                <div><input name="email" type="email" autocomplete="nope"
                                                            placeholder="Email" value=""><label>Email</label></div>
                                                <div>
                                                    <div class="PhoneInput">
                                                        <div class="PhoneInputCountry"><select name="phoneCountry"
                                                                                               aria-label="Phone number country"
                                                                                               class="PhoneInputCountrySelect">
                                                            <option value="ZZ">International</option>
                                                            <option value="AF">Afghanistan</option>
                                                            <option value="AX">Åland Islands</option>
                                                            <option value="AL">Albania</option>
                                                            <option value="DZ">Algeria</option>
                                                            <option value="AS">American Samoa</option>
                                                            <option value="AD">Andorra</option>
                                                            <option value="AO">Angola</option>
                                                            <option value="AI">Anguilla</option>
                                                            <option value="AG">Antigua and Barbuda</option>
                                                            <option value="AR">Argentina</option>
                                                            <option value="AM">Armenia</option>
                                                            <option value="AW">Aruba</option>
                                                            <option value="AC">Ascension Island</option>
                                                            <option value="AU">Australia</option>
                                                            <option value="AT">Austria</option>
                                                            <option value="AZ">Azerbaijan</option>
                                                            <option value="BS">Bahamas</option>
                                                            <option value="BH">Bahrain</option>
                                                            <option value="BD">Bangladesh</option>
                                                            <option value="BB">Barbados</option>
                                                            <option value="BY">Belarus</option>
                                                            <option value="BE">Belgium</option>
                                                            <option value="BZ">Belize</option>
                                                            <option value="BJ">Benin</option>
                                                            <option value="BM">Bermuda</option>
                                                            <option value="BT">Bhutan</option>
                                                            <option value="BO">Bolivia</option>
                                                            <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                                                            <option value="BA">Bosnia and Herzegovina</option>
                                                            <option value="BW">Botswana</option>
                                                            <option value="BR">Brazil</option>
                                                            <option value="IO">British Indian Ocean Territory</option>
                                                            <option value="BN">Brunei Darussalam</option>
                                                            <option value="BG">Bulgaria</option>
                                                            <option value="BF">Burkina Faso</option>
                                                            <option value="MM">Burma</option>
                                                            <option value="BI">Burundi</option>
                                                            <option value="KH">Cambodia</option>
                                                            <option value="CM">Cameroon</option>
                                                            <option value="CA">Canada</option>
                                                            <option value="CV">Cape Verde</option>
                                                            <option value="KY">Cayman Islands</option>
                                                            <option value="CF">Central African Republic</option>
                                                            <option value="TD">Chad</option>
                                                            <option value="CL">Chile</option>
                                                            <option value="CN">China</option>
                                                            <option value="CX">Christmas Island</option>
                                                            <option value="CC">Cocos (Keeling) Islands</option>
                                                            <option value="CO">Colombia</option>
                                                            <option value="KM">Comoros</option>
                                                            <option value="CG">Congo</option>
                                                            <option value="CD">Congo, Democratic Republic of the
                                                            </option>
                                                            <option value="CK">Cook Islands</option>
                                                            <option value="CR">Costa Rica</option>
                                                            <option value="CI">Cote d'Ivoire</option>
                                                            <option value="HR">Croatia</option>
                                                            <option value="CU">Cuba</option>
                                                            <option value="CW">Curaçao</option>
                                                            <option value="CY">Cyprus</option>
                                                            <option value="CZ">Czech Republic</option>
                                                            <option value="DK">Denmark</option>
                                                            <option value="DJ">Djibouti</option>
                                                            <option value="DM">Dominica</option>
                                                            <option value="DO">Dominican Republic</option>
                                                            <option value="EC">Ecuador</option>
                                                            <option value="EG">Egypt</option>
                                                            <option value="SV">El Salvador</option>
                                                            <option value="GQ">Equatorial Guinea</option>
                                                            <option value="ER">Eritrea</option>
                                                            <option value="EE">Estonia</option>
                                                            <option value="ET">Ethiopia</option>
                                                            <option value="FK">Falkland Islands</option>
                                                            <option value="FO">Faroe Islands</option>
                                                            <option value="FM">Federated States of Micronesia</option>
                                                            <option value="FJ">Fiji</option>
                                                            <option value="FI">Finland</option>
                                                            <option value="FR">France</option>
                                                            <option value="GF">French Guiana</option>
                                                            <option value="PF">French Polynesia</option>
                                                            <option value="GA">Gabon</option>
                                                            <option value="GM">Gambia</option>
                                                            <option value="GE">Georgia</option>
                                                            <option value="DE">Germany</option>
                                                            <option value="GH">Ghana</option>
                                                            <option value="GI">Gibraltar</option>
                                                            <option value="GR">Greece</option>
                                                            <option value="GL">Greenland</option>
                                                            <option value="GD">Grenada</option>
                                                            <option value="GP">Guadeloupe</option>
                                                            <option value="GU">Guam</option>
                                                            <option value="GT">Guatemala</option>
                                                            <option value="GG">Guernsey</option>
                                                            <option value="GN">Guinea</option>
                                                            <option value="GW">Guinea-Bissau</option>
                                                            <option value="GY">Guyana</option>
                                                            <option value="HT">Haiti</option>
                                                            <option value="VA">Holy See (Vatican City State)</option>
                                                            <option value="HN">Honduras</option>
                                                            <option value="HK">Hong Kong</option>
                                                            <option value="HU">Hungary</option>
                                                            <option value="IS">Iceland</option>
                                                            <option value="IN">India</option>
                                                            <option value="ID">Indonesia</option>
                                                            <option value="IR">Iran</option>
                                                            <option value="IQ">Iraq</option>
                                                            <option value="IE">Ireland</option>
                                                            <option value="IM">Isle of Man</option>
                                                            <option value="IL">Israel</option>
                                                            <option value="IT">Italy</option>
                                                            <option value="JM">Jamaica</option>
                                                            <option value="JP">Japan</option>
                                                            <option value="JE">Jersey</option>
                                                            <option value="JO">Jordan</option>
                                                            <option value="KZ">Kazakhstan</option>
                                                            <option value="KE">Kenya</option>
                                                            <option value="KI">Kiribati</option>
                                                            <option value="XK">Kosovo</option>
                                                            <option value="KW">Kuwait</option>
                                                            <option value="KG">Kyrgyzstan</option>
                                                            <option value="LA">Laos</option>
                                                            <option value="LV">Latvia</option>
                                                            <option value="LB">Lebanon</option>
                                                            <option value="LS">Lesotho</option>
                                                            <option value="LR">Liberia</option>
                                                            <option value="LY">Libya</option>
                                                            <option value="LI">Liechtenstein</option>
                                                            <option value="LT">Lithuania</option>
                                                            <option value="LU">Luxembourg</option>
                                                            <option value="MO">Macao</option>
                                                            <option value="MG">Madagascar</option>
                                                            <option value="MW">Malawi</option>
                                                            <option value="MY">Malaysia</option>
                                                            <option value="MV">Maldives</option>
                                                            <option value="ML">Mali</option>
                                                            <option value="MT">Malta</option>
                                                            <option value="MH">Marshall Islands</option>
                                                            <option value="MQ">Martinique</option>
                                                            <option value="MR">Mauritania</option>
                                                            <option value="MU">Mauritius</option>
                                                            <option value="YT">Mayotte</option>
                                                            <option value="MX">Mexico</option>
                                                            <option value="MD">Moldova</option>
                                                            <option value="MC">Monaco</option>
                                                            <option value="MN">Mongolia</option>
                                                            <option value="ME">Montenegro</option>
                                                            <option value="MS">Montserrat</option>
                                                            <option value="MA">Morocco</option>
                                                            <option value="MZ">Mozambique</option>
                                                            <option value="NA">Namibia</option>
                                                            <option value="NR">Nauru</option>
                                                            <option value="NP">Nepal</option>
                                                            <option value="NL">Netherlands</option>
                                                            <option value="NC">New Caledonia</option>
                                                            <option value="NZ">New Zealand</option>
                                                            <option value="NI">Nicaragua</option>
                                                            <option value="NE">Niger</option>
                                                            <option value="NG">Nigeria</option>
                                                            <option value="NU">Niue</option>
                                                            <option value="NF">Norfolk Island</option>
                                                            <option value="KP">North Korea</option>
                                                            <option value="MK">North Macedonia</option>
                                                            <option value="MP">Northern Mariana Islands</option>
                                                            <option value="NO">Norway</option>
                                                            <option value="OM">Oman</option>
                                                            <option value="PK">Pakistan</option>
                                                            <option value="PW">Palau</option>
                                                            <option value="PS">Palestine</option>
                                                            <option value="PA">Panama</option>
                                                            <option value="PG">Papua New Guinea</option>
                                                            <option value="PY">Paraguay</option>
                                                            <option value="PE">Peru</option>
                                                            <option value="PH">Philippines</option>
                                                            <option value="PL">Poland</option>
                                                            <option value="PT">Portugal</option>
                                                            <option value="PR">Puerto Rico</option>
                                                            <option value="QA">Qatar</option>
                                                            <option value="RE">Reunion</option>
                                                            <option value="RO">Romania</option>
                                                            <option value="RU">Russia</option>
                                                            <option value="RW">Rwanda</option>
                                                            <option value="BL">Saint Barthélemy</option>
                                                            <option value="SH">Saint Helena</option>
                                                            <option value="KN">Saint Kitts and Nevis</option>
                                                            <option value="LC">Saint Lucia</option>
                                                            <option value="MF">Saint Martin (French Part)</option>
                                                            <option value="PM">Saint Pierre and Miquelon</option>
                                                            <option value="VC">Saint Vincent and the Grenadines</option>
                                                            <option value="WS">Samoa</option>
                                                            <option value="SM">San Marino</option>
                                                            <option value="ST">Sao Tome and Principe</option>
                                                            <option value="SA">Saudi Arabia</option>
                                                            <option value="SN">Senegal</option>
                                                            <option value="RS">Serbia</option>
                                                            <option value="SC">Seychelles</option>
                                                            <option value="SL">Sierra Leone</option>
                                                            <option value="SG">Singapore</option>
                                                            <option value="SX">Sint Maarten</option>
                                                            <option value="SK">Slovakia</option>
                                                            <option value="SI">Slovenia</option>
                                                            <option value="SB">Solomon Islands</option>
                                                            <option value="SO">Somalia</option>
                                                            <option value="ZA">South Africa</option>
                                                            <option value="KR">South Korea</option>
                                                            <option value="SS">South Sudan</option>
                                                            <option value="ES">Spain</option>
                                                            <option value="LK">Sri Lanka</option>
                                                            <option value="SD">Sudan</option>
                                                            <option value="SR">Suriname</option>
                                                            <option value="SJ">Svalbard and Jan Mayen</option>
                                                            <option value="SZ">Swaziland</option>
                                                            <option value="SE">Sweden</option>
                                                            <option value="CH">Switzerland</option>
                                                            <option value="SY">Syria</option>
                                                            <option value="TW">Taiwan</option>
                                                            <option value="TJ">Tajikistan</option>
                                                            <option value="TZ">Tanzania</option>
                                                            <option value="TH">Thailand</option>
                                                            <option value="TL">Timor-Leste</option>
                                                            <option value="TG">Togo</option>
                                                            <option value="TK">Tokelau</option>
                                                            <option value="TO">Tonga</option>
                                                            <option value="TT">Trinidad and Tobago</option>
                                                            <option value="TA">Tristan da Cunha</option>
                                                            <option value="TN">Tunisia</option>
                                                            <option value="TR">Turkey</option>
                                                            <option value="TM">Turkmenistan</option>
                                                            <option value="TC">Turks and Caicos Islands</option>
                                                            <option value="TV">Tuvalu</option>
                                                            <option value="UG">Uganda</option>
                                                            <option value="UA">Ukraine</option>
                                                            <option value="AE">United Arab Emirates</option>
                                                            <option value="GB">United Kingdom</option>
                                                            <option value="US">United States</option>
                                                            <option value="UY">Uruguay</option>
                                                            <option value="UZ">Uzbekistan</option>
                                                            <option value="VU">Vanuatu</option>
                                                            <option value="VE">Venezuela</option>
                                                            <option value="VN">Vietnam</option>
                                                            <option value="VG">Virgin Islands, British</option>
                                                            <option value="VI">Virgin Islands, U.S.</option>
                                                            <option value="WF">Wallis and Futuna</option>
                                                            <option value="EH">Western Sahara</option>
                                                            <option value="YE">Yemen</option>
                                                            <option value="ZM">Zambia</option>
                                                            <option value="ZW">Zimbabwe</option>
                                                        </select>
                                                            <div class="PhoneInputCountryIcon">
                                                                <svg class="PhoneInputCountryIconImg"
                                                                     xmlns="http://www.w3.org/2000/svg"
                                                                     viewBox="0 0 75 50"><title>International</title>
                                                                    <g class="PhoneInputInternationalIconGlobe"
                                                                       stroke="currentColor" fill="none"
                                                                       stroke-width="2" stroke-miterlimit="10">
                                                                        <path stroke-linecap="round"
                                                                              d="M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"></path>
                                                                        <path
                                                                            d="M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"></path>
                                                                        <line x1="26" y1="25" x2="74" y2="25"></line>
                                                                        <line x1="50" y1="1" x2="50" y2="49"></line>
                                                                        <path stroke-linecap="round"
                                                                              d="M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"></path>
                                                                        <path stroke-linecap="round"
                                                                              d="M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"></path>
                                                                    </g>
                                                                    <path class="PhoneInputInternationalIconPhone"
                                                                          stroke="none" fill="currentColor"
                                                                          d="M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"></path>
                                                                </svg>
                                                            </div>
                                                            <div class="PhoneInputCountrySelectArrow"></div>
                                                        </div>
                                                        <input type="tel" autocomplete="nope"
                                                               placeholder="Enter phone number" name="phone"
                                                               class="PhoneInputInput" value=""></div>
                                                    <label id="phone_field">Phone</label></div>
                                            </div>
<!--                                            <div class="style__DatePickerWrapper-sc-1iaf0iy-7 bIGopR">-->
<!--                                                <div class="datePicker"><p><strong>CHOOSE YOUR DATE</strong></p>-->
<!--                                                    <div class="react-datepicker-wrapper">-->
<!--                                                        <div class="react-datepicker__input-container"><input-->
<!--                                                            type="text" value="2021/02/23"-->
<!--                                                            placeholder="Click to select a date" class=""></div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                                <div class="style__FormPreLoader-sc-1iaf0iy-4 hUWiwF"></div>-->
<!--                                            </div>-->
<!--                                            <div class="recaptcha">-->
<!--                                                <div>-->
<!--                                                    <div style="width: 304px; height: 78px;">-->
<!--                                                        <div>-->
<!--                                                            <iframe-->
<!--                                                                src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LeMvsUZAAAAAM554vVgQ4iGCmF9MwNdvKmbgCr_&amp;co=aHR0cHM6Ly9tYXJrZXRlcXVpdHkuY29tOjQ0Mw..&amp;hl=en&amp;type=image&amp;v=pRiAUlKgZOMcFLsfzZTeGtOA&amp;theme=light&amp;size=normal&amp;badge=bottomright&amp;cb=lr6tufpnm80y"-->
<!--                                                                role="presentation" name="a-seqeqqwv20ht" scrolling="no"-->
<!--                                                                sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"-->
<!--                                                                width="304" height="78" frameborder="0"></iframe>-->
<!--                                                        </div>-->
<!--                                                        <textarea id="g-recaptcha-response" name="g-recaptcha-response"-->
<!--                                                                  class="g-recaptcha-response"-->
<!--                                                                  style="width: 250px; height: 40px; border: 1px solid rgb(193, 193, 193); margin: 10px 25px; padding: 0px; resize: none; display: none;"></textarea>-->
<!--                                                    </div>-->
<!--                                                    <iframe style="display: none;"></iframe>-->
<!--                                                </div>-->
<!--                                            </div>-->
                                            <input type="hidden" value="" name="slot_id"><input type="hidden" value=""
                                                                                                name="slot_time"><input
                                            type="hidden" value="" name="slot_date"><input type="hidden" value="en"
                                                                                           name="langcode">
<!--                                            <input-->
<!--                                            type="hidden" value="" name="slot">-->
                                            <input type="hidden" value="false"
                                                                                      name="valid_client">
                                            <div class="fullWidth clearBtn">
                                                <button type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs"><span
                                                    class="caption">Submit Request</span></button>
                                                <a  @click="showfirst()" >Clear</a></div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col" id="second" >
                                <div class="contentVertical contentCenter figWrap">
                                    <figure><img :src="serverurl+'/public/online_support.png'"/></figure>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section v-if="pagedata.layout!=3" class="FrameWork__InnerPageStyled-v8gq48-0 fHTiUO" :style="pagedata.id==53?'':''">
                <div v-if="pagedata.id!=38 && pagedata.layout!=8 && pagedata.layout!=14 && pagedata.layout!=13 && pageblocksdata"
                     class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
                    <div class="style__AboutUsAreaStyled-wl91kn-0 kFrdTN" style="padding-bottom:0px!important;">
                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div class="style__AboutUsListing-wl91kn-1 jLihyS">

                                    <div  class="react-reveal"
                                         style="padding-left:3%;padding-right:3%;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: zoomIn;"
                                         v-for="pageblocks  in pageblocksdata" :key="pageblocks.id">
                                        <div style="line-height:25px!important;font-size:16px!important;" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                            <figure><img
                                                :src="serverurl+'/public/pageblocks/'+pageblocks.icon"/>
                                            </figure>
                                            <br/>
                                            <div
                                                v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr">
                                                {{
                                                    $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr
                                                }}
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                    <div class="FrameWork__AlignCentre-v8gq48-4 calkaF"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="pagedata.id==26 " class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">
                    <div class="style__ShareContentArea-sc-2mirf0-0 htlbQg">
                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                                    <div class="FrameWork__AlignCentre-v8gq48-4 calkaF"></div>
                                </div>
                            </div>
                        </div>
<!--        <div class="FrameWork__Row-v8gq48-2 VIUMD">-->
<!--            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">-->
<!--                <div class="style__TabWrap-sc-2mirf0-1 rbpJY">-->
<!--                    <div class="react-reveal"-->
<!--                         style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">-->
<!--                        <div id="safetyblock1" class="style__ThumbListItemStyled-w7lz1s-0 bNdiGn"-->
<!--                             @click="showdata(1)">-->
<!--                            <figure><img-->
<!--                                :src="serverurl+'/public/pageblocks/20201228131800.png'">-->
<!--                            </figure>-->
<!--                            <div><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family: Comfortaa!important;'">-->
<!--                                {{-->
<!--                                $i18n.locale == 'en' ? ' Segregated Funds' : $i18n.locale == 'العربية' ? 'فصل أموال العملاء' : $i18n.locale == '中文' ? '资金隔离' : 'Ségrégation des Fonds clients'-->
<!--                                }}-->
<!--                            </h3></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="react-reveal"-->
<!--                         style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 240ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">-->
<!--                        <div id="safetyblock2" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"-->
<!--                             @click="showdata(2)">-->
<!--                            <figure><img-->
<!--                                :src="serverurl+'/public/pageblocks/20210112072250.png'">-->
<!--                            </figure>-->
<!--                            <div><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family: Comfortaa!important;'">-->
<!--                                {{-->
<!--                                $i18n.locale == 'en' ? ' Information Encryption ( SSL )' : $i18n.locale == 'العربية' ? '(SSL) تشفير المعلومات' : $i18n.locale == '中文' ? '信息加密' : 'Cryptage des informations (SSL)'-->
<!--                                }}-->
<!--                            </h3></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="react-reveal"-->
<!--                         style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">-->
<!--                        <div id="safetyblock3" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"-->
<!--                             @click="showdata(3)">-->
<!--                            <figure><img-->
<!--                                :src="serverurl+'/public/pageblocks/20210112072515.png'">-->
<!--                            </figure>-->
<!--                            <div><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family: Comfortaa!important;'">-->
<!--                                {{-->
<!--                                $i18n.locale == 'en' ? 'Risk Management' : $i18n.locale == 'العربية' ? 'إدارة المخاطر' : $i18n.locale == '中文' ? '风险管理' : 'Gestion des Risques'-->
<!--                                }}-->
<!--                            </h3></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="react-reveal"-->
<!--                         style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 480ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">-->
<!--                        <div id="safetyblock4" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"-->
<!--                             @click="showdata(4)">-->
<!--                            <figure><img-->
<!--                                :src="serverurl+'/public/pageblocks/20210112072731.png'">-->
<!--                            </figure>-->
<!--                            <div><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family: Comfortaa;'">-->
<!--                                {{-->
<!--                                $i18n.locale == 'en' ? 'Selection Of Banks' : $i18n.locale == 'العربية' ? 'إختيار البنوك' : $i18n.locale == '中文' ? '银行选择' : 'Sélection des Banques'-->
<!--                                }}-->
<!--                            </h3></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="react-reveal"-->
<!--                         style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 600ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">-->
<!--                        <div id="safetyblock5" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"-->
<!--                             @click="showdata(5)">-->
<!--                            <figure><img-->
<!--                                :src="serverurl+'/public/pageblocks/20210112073022.png'">-->
<!--                            </figure>-->
<!--                            <div><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family: Comfortaa;'">-->
<!--                                {{-->
<!--                                $i18n.locale == 'en' ? 'Currency Conversion' : $i18n.locale == 'العربية' ? 'تحويل العملات' : $i18n.locale == '中文' ? '货币转换' : 'Conversion de devises'-->
<!--                                }}-->
<!--                            </h3></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->


<!--                <div v-for="pageblocks  in pageblocksdata" :key="pageblocks.id"-->
<!--                     class="style__TabContent-sc-2mirf0-3 fdbctu" :id="'safetyblockdata'+pageblocks.id"-->
<!--                     :style="pageblocks.id==5?'display:block':'display:none'"-->
<!--                     v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr">-->
<!--                    {{-->
<!--                    $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr-->
<!--                    }}-->
<!--                </div>-->

<!--                <div class="content_default"></div>-->
<!--            </div>-->
<!--        </div>-->                    </div>
                </div>
                <div v-if="pagedata.id==52" class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">
                    <div class="style__ShareContentArea-sc-2mirf0-0 htlbQg">
                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                                    <div class="FrameWork__AlignCentre-v8gq48-4 calkaF"></div>
                                </div>
                            </div>
                        </div>
<!--
    <div class="FrameWork__Row-v8gq48-2 VIUMD">
        <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
            <div class="style__TabWrap-sc-2mirf0-1 rbpJY">
                <div class="react-reveal"
                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                    <div id="platformblock1" class="style__ThumbListItemStyled-w7lz1s-0 bNdiGn"
                         @click="showplatformdata(1)">
                        <figure><img
                            src="https://dev.marketequityinc.com/public/public/pageblocks/20210119131632.png">
                        </figure>
                        <div><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">

                            Windows

                        </h3></div>
                    </div>
                </div>
                <div class="react-reveal"
                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 240ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                    <div id="platformblock2" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                         @click="showplatformdata(2)">
                        <figure><img
                            src="https://dev.marketequityinc.com/public/public/pageblocks/20210119132252.png">
                        </figure>
                        <div><h3>
                            Android
                        </h3></div>
                    </div>
                </div>
                <div class="react-reveal"
                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                    <div id="platformblock3" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                         @click="showplatformdata(3)">
                        <figure><img
                            src="https://dev.marketequityinc.com/public/public/pageblocks/20210119132650.png">
                        </figure>
                        <div><h3>
                            IOS
                        </h3></div>
                    </div>
                </div>
                <div class="react-reveal"
                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 480ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                    <div id="platformblock4" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                         @click="showplatformdata(4)">
                        <figure><img
                            src="https://dev.marketequityinc.com/public/public/pageblocks/20210119132957.png">
                        </figure>
                        <div><h3>
                            Web Trade
                        </h3></div>
                    </div>
                </div>
                <div class="react-reveal"
                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 600ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                    <div id="platformblock5" class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                         @click="showplatformdata(5)">
                        <figure><img
                            src="https://dev.marketequityinc.com/public/public/pageblocks/20210119133154.jpg">
                        </figure>
                        <div><h3>
                            MacOS
                        </h3></div>
                    </div>
                </div>
            </div>


            <div v-for="pageblocks  in pageblocksdata" :key="pageblocks.id"
                 class="style__TabContent-sc-2mirf0-3 fdbctu" :id="'platformblockdata'+pageblocks.id"
                 :style="pageblocks.id==13?'display:block;color:#ffffff!important':'display:none;color:#ffffff!important'"
                 v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr">
                {{
                $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr
                }}
            </div>

            <div class="content_default"></div>
        </div>
    </div>
-->
                    </div>
                </div>

                <div v-if="pagedata.id==53" class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">
                    <div class="style__ShareContentArea-sc-2mirf0-0 htlbQg">
                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">
                                    <div class="FrameWork__AlignCentre-v8gq48-4 calkaF"></div>
                                </div>
                            </div>
                        </div>
                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">

                                <div
                                    v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr"
                                    class="react-reveal" v-for="pageblocks  in pageblocksdata" :key="pageblocks.id"
                                    style="text-align:justify;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-723046516005901-1;">

                                    <p style="text-align: center;">

                                        {{
                                            $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr
                                        }}
                                    </p>

                                </div>


                                <div v-for="pageblocks  in pageblocksdata" :key="pageblocks.id"
                                     class="style__TabContent-sc-2mirf0-3 fdbctu" :id="'safetyblockdata'+pageblocks.id"
                                     :style="pageblocks.id==5?'display:block':'display:none'"
                                     v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr">
                                    {{
                                        $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr
                                    }}
                                </div>

                                <div class="content_default"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="pagedata.layout==14" class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">


                    <div class="react-reveal"
                         style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: zoomIn;"
                         v-for="pageblocks  in pageblocksdata" :key="pageblocks.id">


                        <div style="padding-top:50px;padding-bottom:50px;color:#ffffff;border:0px;"
                             v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr">
                            {{
                                $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr
                            }}
                        </div>

                    </div>

                </div>
                <div style="background-color: #C7C7C7" v-if="pagedata.id==38"  class="FrameWork__ColSm-v8gq48-3 dIoETn">
                    <div style="padding-top:2%" class="react-reveal">
                        <h2 class="style__Title-sc-1c6sbqu-0 iAScOU">
                            {{
                                $i18n.locale == 'en' ? 'OUR SERVICES' : $i18n.locale == 'العربية' ? 'خدماتنا' : $i18n.locale == '中文' ? 'OUR SERVICES' : 'Notre Services'
                            }}
                           </h2>
                    </div>
                    <div align="center"   style="width:75%;margin-left:10%;margin-right: 10%;padding-bottom:5%" class="style__EquityProListStyled-sc-10g6239-0 iMnrlI">
                        <div style="" v-for="pageblocks  in pageblocksdata" :key="pageblocks.id" class="react-reveal">
                            <div  class="style__ProListBlocks-sc-1c6sbqu-1 iLUfUY">
                                <div  class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                    <figure><img
                                        :src="serverurl+'/public/pageblocks/'+pageblocks.icon"/></figure>

                                        <div
                                            v-html="$i18n.locale=='en'?pageblocks.contenten:$i18n.locale=='العربية'?pageblocks.contentar:$i18n.locale=='中文'?pageblocks.contentch:pageblocks.contentfr">
                                            {{
                                                $i18n.locale == 'en' ? pageblocks.contenten : $i18n.locale == 'العربية' ? pageblocks.contentar : $i18n.locale == '中文' ? pageblocks.contentch : pageblocks.contentfr
                                            }}

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="pagedata.id==38" class="style__EquityProBannerStyled-sc-20zeym-0 kWnqYr">
                    <div class="style__HighlightTextStyled-sc-20zeym-1 eutyUX">

                        <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO"><div class=" gatsby-image-wrapper" style="position: relative; overflow: hidden;"><div aria-hidden="true" style="width: 100%; padding-bottom: 30.75%;"></div><picture><img loading="lazy" sizes="(max-width: 1600px) 100vw, 1600px"    :src="serverurl+'/public/marketpro.jpg'"  alt="" style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/></picture></div></figure>

                        <div class="style__BtnWrap-x1nw07-0 ixalPv">
                            <p class="react-reveal" style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                {{

                                    $i18n.locale == 'en' ? '  We Help You To' : $i18n.locale == 'العربية' ? 'نحن نساعدك' : $i18n.locale == '中文' ?  '  We Help You To'  : 'Nous vous aidons à'
                                }}

                               <strong>
                                {{

                                    $i18n.locale == 'en' ? ' INVEST RIGHT' : $i18n.locale == 'العربية' ? 'بالإستثمار الصحيح' : $i18n.locale == '中文' ?  ' INVEST RIGHT'  : 'Investissez bien'
                                }}


                                </strong>
                                {{
                                    $i18n.locale == 'en' ? ' MAKE RIGHT CHOICE NOW' : $i18n.locale == 'العربية' ? 'قُم بإتخاذ القرار الصحيح الآن' : $i18n.locale == '中文' ?  ' MAKE RIGHT CHOICE NOW'  : 'Faites le bon choix maintenant'
                                }}


                                </p>
                            <a href="https://regmktequity.globaltradingnetwork.com/EN/register/start" class="react-reveal btn" style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 121ms; animation-iteration-count: 1; opacity: 1; animation-name: react-reveal-49972346098341-1;">
                                {{
                                    $i18n.locale == 'en' ? ' SIGNUP NOW' : $i18n.locale == 'العربية' ? 'سجل الأن' : $i18n.locale == '中文' ? ' SIGNUP NOW' : ' SIGNUP NOW'
                                }}

                               </a></div></div></div>

                <div v-if="pagedata.id==38" class="row" style="padding-top: 65px;
padding-bottom: 55px;padding-right: 10%;padding-left: 10%;">

                    <h1 align="center">{{
                            $i18n.locale == 'en' ? 'THE MARKETS WE OFFER' : $i18n.locale == 'العربية' ? 'الأسواق التي نوفرها' : $i18n.locale == '中文' ? 'THE MARKETS WE OFFER' : 'Les marchés que nous offrons'
                        }}</h1>
                    <div class=" col-md-12">

                        <div class="panel-group" id="accordionsmarket" role="tablist" aria-multiselectable="true"
                             :style="$i18n.locale=='العربية'?'direction:rtl':'direction:left'">
                            <div v-for="marketswerofferdata in marketsoffer" v-bind:key="marketswerofferdata.id"
                                 class="panel panel-default">
                                <div :style="$i18n.locale=='العربية'?'float:right;width:100%;text-align:right':''"
                                     class="panel-heading" role="tab" id="headingnew">
                                    <h4 class="panel-title">
                                        <a role="button" data-toggle="collapse" data-parent="#accordionsmarket"
                                           :href="'#collapse'+marketswerofferdata.id"
                                           :aria-expanded="marketswerofferdata.id==1?true:false"
                                           aria-controls="collapseOne">
                                            {{ marketswerofferdata.title }}
                                        </a>
                                    </h4>
                                </div>
                                <div :id="'collapse'+marketswerofferdata.id"
                                     class="panel-collapse in collapse"
                                     role="tabpanel" aria-labelledby="headingOne">
                                    <div class="table-responsive panel-body" v-html="$i18n.locale == 'en' ? marketswerofferdata.contenten : $i18n.locale == 'العربية' ? marketswerofferdata.contentar : $i18n.locale == '中文' ? marketswerofferdata.contentch : marketswerofferdata.contentfr">
                                        {{ marketswerofferdata.contenten }}
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </section>
               <section v-if="pagedata.id==47 || pagedata.id==46 || pagedata.id==45" class="FrameWork__InnerPageStyled-v8gq48-0 fHTiUO">
                <div class="style__Details-drs3na-1 kMaaBC" style="margin-top:-5%">
                    <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">


                        <div class="FrameWork__Row-v8gq48-2 VIUMD">
                            <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                <div :style="$i18n.locale == 'العربية' ? 'right:0' :''"
                                     class="style__ListWrap-drs3na-2 ">

                                    <div class="col-md-12" :style="$i18n.locale == 'العربية' ? 'right:0;float:right;padding-right:10%' :'left:0;'">


                                        <form :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;text-align: right !important;padding-right:10%'
 :'float: left;direction:rtl;text-align: left !important;padding-left: 10%;'" class=" jZQfFQ">
                                            <hr class="solid" style="color:#404040!important;">
                                            <br />


                                            <h2 style="color:#1a859d">  {{
                                                            $i18n.locale == 'en' ? 'To Contact Customer Service' : $i18n.locale == 'العربية' ? 'للتواصل مع خدمة العملاء ' : $i18n.locale == '中文' ? 'To Contact Customer Service' : 'To Contact Customer Service'
                                                            }}</h2>
                                            <table class="table">

                                                <tr>
                                                    <td style="border:0" rowspan="6">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                        </label><div>

                                                        <textarea style="width: 100%;
height: 100%;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;" rows="18" v-model="whielabelmessage" name="message" autocomplete="nope"
                                                                                    placeholder="Message"></textarea>
                                                      </div></td>
                                                    <td style="border:0;padding-right:10px;">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Name' : $i18n.locale == 'العربية' ? 'الإسم' : $i18n.locale == '中文' ? '名字' : 'Nom'
                                                            }}
                                                        </label><div>
                                                        <input style="width: 100%;
height: 55px;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;" v-model="whielabelfirstname" name="your_name" type="text" autocomplete="nope"
                                                               placeholder="First Name" value="">

                                                        <!--                                                <div class="error-message">Please enter your name</div>-->
                                                    </div></td></tr>

                                                <tr>
                                                    <td style="border:0">
                                                        <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Email' : $i18n.locale == 'العربية' ? 'البريد الإلكتروني' : $i18n.locale == '中文' ? '邮箱' : 'Adresse email'
                                                            }}
                                                        </label><div >

                                                        <input style="width: 100%;
height: 55px;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;" v-model="whielabelemail" name="email"  type="email" autocomplete="nope"
                                                                                       placeholder="Email" value="">

                                                    </div></td>
                                                </tr>

<!--                                                <tr>-->
<!--                                                    <td><div><input v-model="whielabellastname" name="your_name" type="text" autocomplete="nope"-->
<!--                                                                    placeholder="Last Name" value="">-->
<!--                                                        <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">-->
<!--                                                            {{-->
<!--                                                                $i18n.locale == 'en' ? 'Last Name' : $i18n.locale == 'العربية' ? 'الإسم' : $i18n.locale == '中文' ? '名字' : 'Nom'-->
<!--                                                            }}-->
<!--                                                        </label>-->
<!--                                                        &lt;!&ndash;                                                <div class="error-message">Please enter your name</div>&ndash;&gt;-->
<!--                                                    </div></td>-->
<!--                                                </tr>-->


<!--                                            </table>-->

                                            <tr>
                                                <td style="border:0">
                                                    <label :style="$i18n.locale == 'العربية' ? 'float: right;direction:rtl;right:0;font-family:  Cairo!important':'float: left;direction:ltr;left:0'">
                                                        {{
                                                            $i18n.locale == 'en' ? 'Country' : $i18n.locale == 'العربية' ?'الدولة' : $i18n.locale == '中文' ? '邮箱' : 'Country'
                                                        }}
                                                    </label>
                                            <div class="SelectField"><div class="CustomSelectInput" >



<select v-model="whielabelcountry" style="width: 100%;
height: 55px;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;"

        :class="$i18n.locale=='العربية'?'form-control rtlclass':'form-control ltrclass'"
        id="countries" @change="onChange($event)">


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KW" value="965,120">
        {{ $i18n.locale == 'العربية' ? 'الكويت' : 'Kuwait' }}
    </option>
    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="213,3">
        {{ $i18n.locale == 'العربية' ? 'الجزائر' : 'Algeria' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AD" value="376,5">
        {{ $i18n.locale == 'العربية' ? 'أندورا' : 'Andorra' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AI" value="1264,7">
        {{ $i18n.locale == 'العربية' ? 'أنجويلا' : 'Anguilla' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AG" value="1268,9">{{
            $i18n.locale == 'العربية' ? 'أنتيغوا وباربودا' : 'Antigua &amp; Barbuda'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AR" value="54,11">
        {{ $i18n.locale == 'العربية' ? 'الأرجنتين' : 'Argentina' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AM" value="374,12">
        {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Armenia' }}
    </option>
    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AW" value="297,13">
        {{ $i18n.locale == 'العربية' ? 'أرمينيا' : 'Aruba' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AU" value="61,14">
        {{ $i18n.locale == 'العربية' ? 'أستراليا' : 'Australia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AT" value="43,15">
        {{ $i18n.locale == 'العربية' ? 'النمسا' : 'Austria' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AZ" value="994,16">
        {{ $i18n.locale == 'العربية' ? 'أذربيجان' : 'Azerbaijan' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BS" value="1242,17">
        {{ $i18n.locale == 'العربية' ? 'باهاماس' : 'Bahamas' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BH" value="973,18">
        {{ $i18n.locale == 'العربية' ? 'البحرين' : 'Bahrain' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BD" value="880,19">
        {{ $i18n.locale == 'العربية' ? 'بنجلاديش' : 'Bangladesh' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BB" value="1246,20">
        {{ $i18n.locale == 'العربية' ? 'باربادوس' : 'Barbados' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BY" value="375,21">
        {{ $i18n.locale == 'العربية' ? 'بيلاروس' : 'Belarus' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BE" value="32,22">
        {{ $i18n.locale == 'العربية' ? 'بلجيكا' : 'Belgium' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BZ" value="501,23">
        {{ $i18n.locale == 'العربية' ? 'بيليز' : 'Belize' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BJ" value="229,24">
        {{ $i18n.locale == 'العربية' ? 'بنين' : 'Benin' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="1441,25">
        {{ $i18n.locale == 'العربية' ? 'برمودا' : 'Bermuda' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="975" value="975,26">
        {{ $i18n.locale == 'العربية' ? 'بوتان' : 'Bhutan' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BO" value="591,27">
        {{ $i18n.locale == 'العربية' ? 'بوليفيا' : 'Bolivia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="213,268">{{
            $i18n.locale == 'العربية' ? 'البوسنة والهرسك' : 'Bosnia Herzegovina'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BW" value="267,29">
        {{ $i18n.locale == 'العربية' ? 'بوتسوانا' : 'Botswana' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BR" value="55,30">
        {{ $i18n.locale == 'العربية' ? 'البرازيل' : 'Brazil' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="213,31">
        {{ $i18n.locale == 'العربية' ? 'بروناي' : 'Brunei' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BG" value="359,35">
        {{ $i18n.locale == 'العربية' ? 'بلغاريا' : 'Bulgaria' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="213">
        {{ $i18n.locale == 'العربية' ? 'بوركينا فاسو ' : 'Burkina Faso' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="BI" value="257">
        {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Burundi' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KH" value="855">
        {{ $i18n.locale == 'العربية' ? 'بوروندي' : 'Cambodia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CM" value="237,39">
        {{ $i18n.locale == 'العربية' ? 'كاميرون' : 'Cameroon' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CA" value="1,40">
        {{ $i18n.locale == 'العربية' ? 'كندا' : 'Canada' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="238,41">{{
            $i18n.locale == 'العربية' ? 'الرأس الأخضر' : 'Cape Verde Islands'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="1345,42">
        {{ $i18n.locale == 'العربية' ? 'جزر كايمان' : 'Cayman Islands' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CF" value="236,43">{{
            $i18n.locale == 'العربية' ? 'جمهورية أفريقيا الوسطى' : 'Central African Republic'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CL" value="56,45">
        {{ $i18n.locale == 'العربية' ? 'تشيلي' : 'Chile' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CN" value="86,46">
        {{ $i18n.locale == 'العربية' ? 'الصين' : 'China' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CO" value="57,49">
        {{ $i18n.locale == 'العربية' ? 'كولومبيا' : 'Colombia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KM" value="269,50">
        {{ $i18n.locale == 'العربية' ? 'جزر القمر' : 'Comoros' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="242,51">
        {{ $i18n.locale == 'العربية' ? 'جمهورية الكونغو' : 'Congo' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CK" value="682,52">
        {{ $i18n.locale == 'العربية' ? 'جزر كوك' : 'Cook Islands' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CR" value="506,53">
        {{ $i18n.locale == 'العربية' ? 'كوستاريكا' : 'Costa Rica' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="HR" value="385,55">
        {{ $i18n.locale == 'العربية' ? 'كرواتيا' : 'Croatia' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="CU" value="53">-->
<!--        {{ $i18n.locale == 'العربية' ? 'كوبا' : 'Cuba' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CY" value="90392,57">
        {{ $i18n.locale == 'العربية' ? 'قبرص' : 'Cyprus North' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CZ" value="42,58">{{
            $i18n.locale == 'العربية' ? 'جمهورية التشيك' : 'Czech Republic'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DK" value="45,59">
        {{ $i18n.locale == 'العربية' ? 'الدنمارك' : 'Denmark' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DJ" value="253,60">
        {{ $i18n.locale == 'العربية' ? 'جيبوتي' : 'Djibouti' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DM" value="1809,62">
        {{ $i18n.locale == 'العربية' ? 'دومينيكا' : 'Dominica' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DO" value="1809,62">{{
            $i18n.locale == 'العربية' ? 'جمهورية الدومينيكان' : 'Dominican Republic'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="EC" value="593,64">
        {{ $i18n.locale == 'العربية' ? 'الإكوادور' : 'Ecuador' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="EG" value="20,65">
        {{ $i18n.locale == 'العربية' ? 'مصر' : 'Egypt' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SV" value="213,66">
        {{ $i18n.locale == 'العربية' ? 'السلفادور' : 'El Salvador' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GQ" value="240,67">{{
            $i18n.locale == 'العربية' ? 'غينيا الاستوائية ' : 'Equatorial Guinea'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ER" value="213">
        {{ $i18n.locale == 'العربية' ? 'إريتريا' : 'Eritrea' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="EE" value="372,69">
        {{ $i18n.locale == 'العربية' ? 'إستونيا' : 'Estonia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ET" value="251,71">
        {{ $i18n.locale == 'العربية' ? 'إثيوبيا' : 'Ethiopia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="FK" value="500,72">
        {{ $i18n.locale == 'العربية' ? 'جزر فوكلاند' : 'Falkland Islands' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="FO" value="298,73">
        {{ $i18n.locale == 'العربية' ? 'جزر فارو' : 'Faroe Islands' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="FJ" value="679,75">
        {{ $i18n.locale == 'العربية' ? 'فيجي' : 'Fiji' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="FI" value="358,76">
        {{ $i18n.locale == 'العربية' ? 'فنلندا' : 'Finland' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="FR" value="33,77">
        {{ $i18n.locale == 'العربية' ? 'فرنسا' : 'France' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GF" value="594,79">
        {{ $i18n.locale == 'العربية' ? 'غينيا الفرنسية' : 'French Guiana' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PF" value="689,81">{{
            $i18n.locale == 'العربية' ? 'بولينيزيا الفرنسية' : 'French Polynesia'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GA" value="241,84">
        {{ $i18n.locale == 'العربية' ? 'الغابون' : 'Gabon' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GM" value="220,85">
        {{ $i18n.locale == 'العربية' ? 'غامبيا' : 'Gambia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GE" value="7880,86">
        {{ $i18n.locale == 'العربية' ? 'جورجيا' : 'Georgia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DE" value="49,87">
        {{ $i18n.locale == 'العربية' ? 'ألمانيا' : 'Germany' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GH" value="233,88">
        {{ $i18n.locale == 'العربية' ? 'غانا' : 'Ghana' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GR" value="30">
        {{ $i18n.locale == 'العربية' ? 'اليونان' : 'Greece' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GL" value="299,90">
        {{ $i18n.locale == 'العربية' ? 'جرينلاند' : 'Greenland' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GD" value="1473,92">
        {{ $i18n.locale == 'العربية' ? 'غرينادا' : 'Grenada' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GP" value="590,93">
        {{ $i18n.locale == 'العربية' ? 'غوادلوب' : 'Guadeloupe' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GU" value="671">
        {{ $i18n.locale == 'العربية' ? 'غوام' : 'Guam' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="DZ" value="502,94">
        {{ $i18n.locale == 'العربية' ? 'غواتيمال' : 'Guatemala' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GN" value="224,96">
        {{ $i18n.locale == 'العربية' ? 'غينيا' : 'Guinea' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GW" value="245,97">
        {{ $i18n.locale == 'العربية' ? 'غينيا بيساو' : 'Guinea - Bissau' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="GY" value="592,98">
        {{ $i18n.locale == 'العربية' ? 'غيانا' : 'Guyana' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="HT" value="509">-->
<!--        {{ $i18n.locale == 'العربية' ? 'هايتي' : 'Haiti' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="HN" value="504,101">
        {{ $i18n.locale == 'العربية' ? 'هندوراس' : 'Honduras' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="HK" value="852,271">
        {{ $i18n.locale == 'العربية' ? 'هونج كونج' : 'Hong Kong' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="HU" value="36,103">
        {{ $i18n.locale == 'العربية' ? 'المجر' : 'Hungary' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IS" value="354,31">
        {{ $i18n.locale == 'العربية' ? 'أيسلندا' : 'Iceland' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IN" value="91,105">
        {{ $i18n.locale == 'العربية' ? 'الهند' : 'India' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ID" value="62,106">
        {{ $i18n.locale == 'العربية' ? 'اندونيسيا' : 'Indonesia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IR" value="98">
        {{ $i18n.locale == 'العربية' ? 'ايران' : 'Iran' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IQ" value="964">
        {{ $i18n.locale == 'العربية' ? 'العراق' : 'Iraq' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IE" value="353,109">
        {{ $i18n.locale == 'العربية' ? 'جمهورية أيرلندا ' : 'Ireland' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IL" value="972">
        {{ $i18n.locale == 'العربية' ? 'إسرائيل' : 'Israel' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IT" value="39,111">
        {{ $i18n.locale == 'العربية' ? 'إيطاليا' : 'Italy' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="JM" value="1876">-->
<!--        {{ $i18n.locale == 'العربية' ? 'جامايكا' : 'Jamaica' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="JP" value="81,113">
        {{ $i18n.locale == 'العربية' ? 'اليابان' : 'Japan' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="JO" value="962,114">
        {{ $i18n.locale == 'العربية' ? 'الأردن' : 'Jordan' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KZ" value="7,272">
        {{ $i18n.locale == 'العربية' ? 'كازاخستان' : 'Kazakhstan' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KE" value="254,116">
        {{ $i18n.locale == 'العربية' ? 'كينيا' : 'Kenya' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KI" value="686,117">
        {{ $i18n.locale == 'العربية' ? 'كيريباتي' : 'Kiribati' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KP" value="850,273">
        {{ $i18n.locale == 'العربية' ? 'كوريا الشمالية' : 'Korea North' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KR" value="82,273">
        {{ $i18n.locale == 'العربية' ? 'كوريا الجنوبية ' : 'Korea South' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="KG" value="996">
        {{ $i18n.locale == 'العربية' ? 'قيرغيزستان' : 'Kyrgyzstan' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LA" value="856,121">
        {{ $i18n.locale == 'العربية' ? 'لاوس' : 'Laos' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LV" value="371,123">
        {{ $i18n.locale == 'العربية' ? 'لاتفيا' : 'Latvia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LB" value="961,124">
        {{ $i18n.locale == 'العربية' ? 'لبنان' : 'Lebanon' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LS" value="266,125">
        {{ $i18n.locale == 'العربية' ? 'ليسوتو' : 'Lesotho' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LR" value="231,126">
        {{ $i18n.locale == 'العربية' ? 'ليبيريا' : 'Liberia' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="LY" value="218">-->
<!--        {{ $i18n.locale == 'العربية' ? 'ليبيا' : 'Libya' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LI" value="417,128">
        {{ $i18n.locale == 'العربية' ? 'ليختنشتاين' : 'Liechtenstein' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LT" value="370,129">
        {{ $i18n.locale == 'العربية' ? 'ليتوانيا' : 'Lithuania' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LU" value="352,130">
        {{ $i18n.locale == 'العربية' ? 'لوكسمبورغ' : 'Luxembourg' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MK" value="389,83">
        {{ $i18n.locale == 'العربية' ? 'مقدونيا الشمالية' : 'Macedonia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MG" value="261,132">
        {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Madagascar' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MW" value="265,133">
        {{ $i18n.locale == 'العربية' ? 'مدغشقر' : 'Malawi' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MY" value="60,134">
        {{ $i18n.locale == 'العربية' ? 'ماليزيا' : 'Malaysia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MV" value="960,135">
        {{ $i18n.locale == 'العربية' ? 'المالديف' : 'Maldives' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ML" value="223,136">
        {{ $i18n.locale == 'العربية' ? 'مالي' : 'Mali' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="MT" value="356">-->
<!--        {{ $i18n.locale == 'العربية' ? 'مالطا' : 'Malta' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MH" value="692,138">
        {{ $i18n.locale == 'العربية' ? 'جزر مارشال' : 'Marshall Islands' }}
    </option>
    >

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MQ" value="596,139">
        {{ $i18n.locale == 'العربية' ? 'مارتينيك' : 'Martinique' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MR" value="222,140">
        {{ $i18n.locale == 'العربية' ? 'موريتانيا' : 'Mauritania' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="YT" value="269,142">
        {{ $i18n.locale == 'العربية' ? 'مايوت' : 'Mayotte' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MX" value="52,143">
        {{ $i18n.locale == 'العربية' ? 'المكسيك' : 'Mexico' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MD" value="373">
        {{ $i18n.locale == 'العربية' ? 'مولدوفا' : 'Moldova' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MC" value="377,275">
        {{ $i18n.locale == 'العربية' ? 'موناكو' : 'Monaco' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MN" value="976,147">
        {{ $i18n.locale == 'العربية' ? 'منغوليا' : 'Mongolia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MS" value="1664,148">
        {{ $i18n.locale == 'العربية' ? 'مونتسرات' : 'Montserrat' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="MA" value="212">-->
<!--        {{ $i18n.locale == 'العربية' ? 'المغرب' : 'Morocco' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="MZ" value="258,150">
        {{ $i18n.locale == 'العربية' ? 'موزمبيق' : 'Mozambique' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="MN" value="95">-->
<!--        {{ $i18n.locale == 'العربية' ? 'ميانمار' : 'Myanmar' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NA" value="264,152">
        {{ $i18n.locale == 'العربية' ? 'ناميبيا' : 'Namibia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NR" value="674,153">
        {{ $i18n.locale == 'العربية' ? 'ناورو' : 'Nauru' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NP" value="977,154">
        {{ $i18n.locale == 'العربية' ? 'نيبال' : 'Nepal' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NL" value="31,155">
        {{ $i18n.locale == 'العربية' ? 'هولندا' : 'Netherlands' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NC" value="687,155">{{
            $i18n.locale == 'العربية' ? 'كاليدونيا الجديدة ' : 'New Caledonia'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NZ" value="64,158">
        {{ $i18n.locale == 'العربية' ? 'نيوزيلندا' : 'New Zealand' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="NI" value="505">-->
<!--        {{ $i18n.locale == 'العربية' ? 'نيكاراجوا' : 'Nicaragua' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NE" value="227,160">
        {{ $i18n.locale == 'العربية' ? 'النيجر' : 'Niger' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NG" value="234,161">
        {{ $i18n.locale == 'العربية' ? 'نيجيريا' : 'Nigeria' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="NO" value="47,165">
        {{ $i18n.locale == 'العربية' ? 'النرويج' : 'Norway' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="OM" value="968,166">
        {{ $i18n.locale == 'العربية' ? 'عُمان' : 'Oman' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PW" value="680,168">
        {{ $i18n.locale == 'العربية' ? 'بالاو' : 'Palau' }}
    </option>
    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="IL" value="972,278">
        {{ $i18n.locale == 'العربية' ? 'فلسطين' : 'Palestine' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="PA" value="507">-->
<!--        {{ $i18n.locale == 'العربية' ? 'بنما' : 'Panama' }}-->
<!--    </option>-->


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PG" value="675,170">{{
            $i18n.locale == 'العربية' ? 'بابوا غينيا الجديدة' : 'Papua New Guinea'
        }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PY" value="595,171">
        {{ $i18n.locale == 'العربية' ? 'باراغواي' : 'Paraguay' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PE" value="51,172">
        {{ $i18n.locale == 'العربية' ? 'بيرو' : 'Peru' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="PH" value="63">-->
<!--        {{ $i18n.locale == 'العربية' ? 'الفلبين' : 'Philippines' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PL" value="48,175">
        {{ $i18n.locale == 'العربية' ? 'بولندا' : 'Poland' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PT" value="351,176">
        {{ $i18n.locale == 'العربية' ? 'البرتغال' : 'Portugal' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="PR" value="1787,177">
        {{ $i18n.locale == 'العربية' ? 'بورتوريكو' : 'Puerto Rico' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="QA" value="974,178">
        {{ $i18n.locale == 'العربية' ? 'قطر' : 'Qatar' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="RE" value="262,179">
        {{ $i18n.locale == 'العربية' ? 'ريونيون' : 'Reunion' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="RO" value="40,180">
        {{ $i18n.locale == 'العربية' ? 'رومانيا' : 'Romania' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="RU" value="7,181">
        {{ $i18n.locale == 'العربية' ? 'روسيا' : 'Russia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="RW" value="250,182">
        {{ $i18n.locale == 'العربية' ? 'رواندا' : 'Rwanda' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SM" value="378,191">
        {{ $i18n.locale == 'العربية' ? 'سان مارينو' : 'San Marino' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SA" value="966,194">
        {{ $i18n.locale == 'العربية' ? 'السعودية' : 'Saudi Arabia' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="SN" value="221">-->
<!--        {{ $i18n.locale == 'العربية' ? 'السنغال' : 'Senegal' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CS" value="381,265">
        {{ $i18n.locale == 'العربية' ? 'صربيا' : 'Serbia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SC" value="248,196">
        {{ $i18n.locale == 'العربية' ? 'سيشل' : 'Seychelles' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SL" value="232,197">
        {{ $i18n.locale == 'العربية' ? 'سيراليون' : 'Sierra Leone' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SG" value="65,198">
        {{ $i18n.locale == 'العربية' ? 'سنغافورة' : 'Singapore' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SK" value="421,199">
        {{ $i18n.locale == 'العربية' ? 'سلوفاكيا' : 'Slovak Republic' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SI" value="386,200">
        {{ $i18n.locale == 'العربية' ? 'سلوفينيا' : 'Slovenia' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SB" value="677,201">
        {{ $i18n.locale == 'العربية' ? 'جزر سليمان' : 'Solomon Islands' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="SO" value="252">-->
<!--        {{ $i18n.locale == 'العربية' ? 'الصومال' : 'Somalia' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ZA" value="27,203">
        {{ $i18n.locale == 'العربية' ? 'جنوب أفريقيا' : 'South Africa' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ES" value="34,205">
        {{ $i18n.locale == 'العربية' ? 'إسبانيا' : 'Spain' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="LK" value="94,206">
        {{ $i18n.locale == 'العربية' ? 'سريلانكا' : 'Sri Lanka' }}
    </option>


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="SD" value="249">-->
<!--        {{ $i18n.locale == 'العربية' ? 'السودان' : 'Sudan' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SR" value="597,208">
        {{ $i18n.locale == 'العربية' ? 'سورينام' : 'Suriname' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SZ" value="268,210">{{
            $i18n.locale == 'العربية' ? 'سوازيلند (إسواتيني) ' : 'Swaziland'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="SE" value="46,211">
        {{ $i18n.locale == 'العربية' ? 'السويد' : 'Sweden' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="CH" value="41,212">
        {{ $i18n.locale == 'العربية' ? 'سويسرا	' : 'Switzerland' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="SI" value="963">-->
<!--        {{ $i18n.locale == 'العربية' ? 'سوريا' : 'Syria' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TW" value="886,214">
        {{ $i18n.locale == 'العربية' ? 'تايوان' : 'Taiwan' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TH" value="66,217">
        {{ $i18n.locale == 'العربية' ? 'تايلند' : 'Thailand' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TG" value="228,218">
        {{ $i18n.locale == 'العربية' ? 'توغو' : 'Togo' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TO" value="676,220">
        {{ $i18n.locale == 'العربية' ? 'تونغا' : 'Tonga' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TT" value="1868,221">{{
            $i18n.locale == 'العربية' ? 'ترينيداد وتوباغو ' : 'Trinidad &amp; Tobago'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TN" value="216,222">
        {{ $i18n.locale == 'العربية' ? 'تونس' : 'Tunisia' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TR" value="90,223">
        {{ $i18n.locale == 'العربية' ? 'تركيا' : 'Turkey' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TM" value="7,224">
        {{ $i18n.locale == 'العربية' ? 'تركمانستان' : 'Turkmenistan' }}
    </option>



    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="TV" value="688,226">
        {{ $i18n.locale == 'العربية' ? 'توفالو' : 'Tuvalu' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="UG" value="256">-->
<!--        {{ $i18n.locale == 'العربية' ? 'أوغندا' : 'Uganda' }}-->
<!--    </option>-->


<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="UA" value="380">-->
<!--        {{ $i18n.locale == 'العربية' ? 'أوكرانيا' : 'Ukraine' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="AE" value="971,229">{{
            $i18n.locale == 'العربية' ? 'الإمارات' : 'Unitied Arab Emirates'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="UY" value="598,233">
        {{ $i18n.locale == 'العربية' ? 'أوروغواي' : 'Uruguay' }}
    </option>


    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="UZ" value="7,234">
        {{ $i18n.locale == 'العربية' ? 'أوزبكستان' : 'Uzbekistan' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="VU" value="678,235">
        {{ $i18n.locale == 'العربية' ? 'فانواتو' : 'Vanuatu' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="VA" value="379,236">
        {{ $i18n.locale == 'العربية' ? 'الفاتيكان' : 'Vatican City' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="VE" value="58">-->
<!--        {{ $i18n.locale == 'العربية' ? 'فنزويلا' : 'Venezuela' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="VN" value="84,238">
        {{ $i18n.locale == 'العربية' ? 'فيتنام' : 'Vietnam' }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="VG" value="84,239">{{
            $i18n.locale == 'العربية' ? 'جزر العذراء البريطانية' : 'Virgin Islands - British'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="VI" value="84,240">{{
            $i18n.locale == 'العربية' ? 'جزر العذراء الأمريكية' : 'Virgin Islands - US'
        }}
    </option>

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="WF" value="681,241">{{
            $i18n.locale == 'العربية' ? 'واليس وفوتونا' : 'Wallis &amp; Futuna'
        }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="YE" value="969">-->
<!--        {{ $i18n.locale == 'العربية' ? 'اليمن الشمال' : 'Yemen (North)' }}-->
<!--    </option>-->

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="YE" value="967">-->
<!--        {{ $i18n.locale == 'العربية' ? 'اليمن الجنوب' : 'Yemen (South)' }}-->
<!--    </option>-->

    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"
            data-countryCode="ZM" value="260,246">
        {{ $i18n.locale == 'العربية' ? 'زامبيا' : 'Zambia' }}
    </option>

<!--    <option :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'"-->
<!--            data-countryCode="ZW" value="263">-->
<!--        {{ $i18n.locale == 'العربية' ? 'زيمبابوي' : 'Zimbabwe' }}-->
<!--    </option>-->
</select>




<!--                                                <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0;color: rgb(153, 153, 153);':'float: left;direction:ltr;left:0;color: rgb(153, 153, 153);'">-->
<!--                                                    {{-->
<!--                                                        $i18n.locale == 'en' ? 'Country' : $i18n.locale == 'العربية' ? 'موضوع' : $i18n.locale == '中文' ? '主题' : 'Sujet'-->
<!--                                                    }}-->

<!--                                                </label>-->
                                            </div></div>
                                                   </td>
                                            </tr>
                                                <tr>
                                                    <td style="border:0">
                                                        <label :style="$i18n.locale == 'العربية' ? 'font-family:  Cairo!important;float: right;direction:rtl;right:0':'float: left;direction:ltr;left:0'">
                                                            {{
                                                                $i18n.locale == 'en' ? 'Mobile' : $i18n.locale == 'العربية' ? 'رقم الهاتف' : $i18n.locale == '中文' ? '主题' : 'Sujet'
                                                            }}

                                                        </label>
                                                        <div><input style="width: 100%;
height: 55px;
margin: 0px auto;
border: 2px black solid;
border-radius: 10px;"  v-model="whielabelmobile" name="subject" type="text" autocomplete="nope"
                                                                    placeholder="Mobile" >
                                                           </div>

                                                            <div><input v-if="pagedata.id==46" id="leadsource" value="Introducing Broker"  v-model="leadsource" name="leadsource" type="hidden" autocomplete="nope"
                                                                     >
                                                                     <input v-if="pagedata.id==45"  id="leadsource" value="Affiliate Program"  v-model="leadsource" name="leadsource" type="hidden" autocomplete="nope"
                                                                     >
                                                                      <input v-if="pagedata.id==47" id="leadsource"  value="White Label Program"  v-model="leadsource" name="leadsource" type="hidden" autocomplete="nope"
                                                                     >
                                                           </div>
                                                    </td>
                                                </tr>


                                            </table>
                                            <div class="buttonHolder" style="text-align: center;">
                                                <button  :disabled="this.isDisabled" type="button" class="style__ButtonWrap-sc-1i4p4w8-0 UOTGs" @click="requestwhitelabel()"><span
                                                    class="caption">
                                                {{
                                                        $i18n.locale == 'en' ? 'Submit Request' : $i18n.locale == 'العربية' ? 'قدم' : $i18n.locale == '中文' ? '提交' : 'Envoyer votre demande'
                                                    }}
                                                </span></button>
                                            </div>


                                            <p style="color:green" v-if="this.whitelabelsuccess">{{whitelabelsuccess}}</p>


                                        </form>
                                    </div>


                                    <div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


            </section>






            <iframe style="display: none; position: fixed; border: 0px none; overflow: hidden;"
                    src="https://marketequity.ladesk.com/scripts/generateWidget.php?v=5.21.17.15&amp;t=1607084151&amp;cwid=e00b30c6&amp;cwrt=C&amp;cwt=chat&amp;pt=Home%20page%20-%20Market%20Equity%20Inc%20-%20Leading%20Trading%20Service%20Provider&amp;ref=https%3A%2F%2Fmarketequity.com%2Fen%2F%23speciality"
                    allowfullscreen="true" allow="microphone; camera" tabindex="-1" class="i-embedded-chat"
                    id="icb_e00b30c6_305"></iframe>


            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'page',
    data() {
        return {
            pagedata: '',
            pageblocksdata: '',
            contactdata: '',
            contractcat: '',
            contractspecdetails: '',
            pagenameroute: '',
            learningcoursesen: '',
            learningcoursesar: '',
            currencydata: '',
            crossesdata: '',
            articlesdata: '',
            currentdate: '',
            dayname: '',
            daynamear: '',
            swapsrate: '',
            swapscat: '',
            marketswerofferdata:'',
            faqcategories:'',
            faq:'',
            name:'',
            email:'',
            message:'',
            emailnotify:null,
            subject:'',
            whielabelfirstname:'',
            whielabellastname:'',
            whielabelemail:'',
            whielabelcountry:'965',
            whielabelmobile:'',
            whielabelmessage:'',
            whitelabelsuccess:'',
            whitelabelcountryname:'Kuwait',
            isDisabled:false,
            leadsource:'',
            countrycode:120,

        }
    },
    components: {
        Header,
        Footer
    },
    mounted() {



        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js')
        document.head.appendChild(recaptchaScript)
    },
    beforeMount() {
        var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }
 if (pathvalues[1] == 'ru') {
            this.$i18n.locale = 'Русский';
        }

        this.pagenameroute = pathvalues[2];
        this.loadpagedata(pathvalues[2]);
    },

    methods: {
        onChange(event) {
            // var optionValue = event.target.value;
            // var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.whitelabelcountryname=event.target.options[event.target.options.selectedIndex].text;
            // alert( this.registercountryname)

        },

        requestwhitelabel(){
       var countrycodevalues = (this.whielabelcountry).split(",");
       this.countrycode=countrycodevalues[1] ;
         this.whielabelcountry=countrycodevalues[0] ;


            this.$axios.get("whitelabelregister", {
                params: {

                    whielabelfirstname: this.whielabelfirstname,
                    whielabellastname: this.whielabellastname,
                    whielabelemail: this.whielabelemail,
                    whielabelcountry: this.whielabelcountry,
                    whitelabelcountrycode:this.countrycode,
                    whielabelmobile: this.whielabelmobile,
                    whielabelmessage: this.whielabelmessage,
                    whitelabelcountryname:this.whitelabelcountryname,
                    leadsource:this.leadsource


                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        this.whitelabelsuccess="Thank you for your Queries. We will getback you soon";
                        this.isDisabled=true;
                        this.whielabelfirstname='';
                           this.whielabellastname='';
                            this.whielabelemail='';
                            this.whielabelcountry='965',
                            this.whielabelmobile='';
                            this.whielabelmessage='';
                            this.whitelabelcountryname="Kuwait"
                        //alert(this.whitelabelsuccess);

                    }
                });

        },
          showsecond() {

            document.getElementById("seconddiv").style.display = "block";
            document.getElementById("firstdiv").style.display = "none";
            document.getElementById("buttons").style.display = "none";

        },
        showfirst() {

            document.getElementById("seconddiv").style.display = "none";
            document.getElementById("firstdiv").style.display = "block";
            document.getElementById("buttons").style.display = "block";

        },
         submitForm(){

             let formData = {
                 name:this.name,
                 email:this.email,
                message:this.message,
                 subject:this.subject,
             };
            this.emailnotify="Thank you for contacting Market Equity"

             return this.$axios.get('contactsubmit', formData).then(data => {
                 this.emailnotify="Thank you for contacting Market Equity"
                 console.log(data);
             });
        },
        showdata(data) {
            if (data == 1) {
                document.getElementById("safetyblock1").classList.remove("lcaeBj");
                document.getElementById("safetyblock1").classList.add("bNdiGn");
                document.getElementById("safetyblock2").classList.remove("bNdiGn");
                document.getElementById("safetyblock3").classList.remove("bNdiGn");
                document.getElementById("safetyblock4").classList.remove("bNdiGn");
                document.getElementById("safetyblock5").classList.remove("bNdiGn");
                document.getElementById("safetyblockdata5").style.display = "block";
                document.getElementById("safetyblockdata8").style.display = "none";
                document.getElementById("safetyblockdata9").style.display = "none";
                document.getElementById("safetyblockdata11").style.display = "none";
                document.getElementById("safetyblockdata10").style.display = "none";


            }
            if (data == 2) {
                document.getElementById("safetyblock2").classList.remove("lcaeBj");
                document.getElementById("safetyblock2").classList.add("bNdiGn");
                document.getElementById("safetyblock1").classList.remove("bNdiGn");
                document.getElementById("safetyblock3").classList.remove("bNdiGn");
                document.getElementById("safetyblock4").classList.remove("bNdiGn");
                document.getElementById("safetyblock5").classList.remove("bNdiGn");

                document.getElementById("safetyblockdata5").style.display = "none";

                document.getElementById("safetyblockdata8").style.display = "block";
                document.getElementById("safetyblockdata9").style.display = "none";
                document.getElementById("safetyblockdata11").style.display = "none";
                document.getElementById("safetyblockdata10").style.display = "none";


            }
            if (data == 3) {
                document.getElementById("safetyblock3").classList.remove("lcaeBj");
                document.getElementById("safetyblock3").classList.add("bNdiGn");
                document.getElementById("safetyblock2").classList.remove("bNdiGn");
                document.getElementById("safetyblock1").classList.remove("bNdiGn");
                document.getElementById("safetyblock4").classList.remove("bNdiGn");
                document.getElementById("safetyblock5").classList.remove("bNdiGn");
                document.getElementById("safetyblockdata5").style.display = "none";
                document.getElementById("safetyblockdata9").style.display = "block";
                document.getElementById("safetyblockdata8").style.display = "none";
                document.getElementById("safetyblockdata11").style.display = "none";
                document.getElementById("safetyblockdata10").style.display = "none";


            }
            if (data == 4) {

                document.getElementById("safetyblock4").classList.remove("lcaeBj");
                document.getElementById("safetyblock4").classList.add("bNdiGn");
                document.getElementById("safetyblock1").classList.remove("bNdiGn");
                document.getElementById("safetyblock3").classList.remove("bNdiGn");
                document.getElementById("safetyblock2").classList.remove("bNdiGn");
                document.getElementById("safetyblock5").classList.remove("bNdiGn");
                document.getElementById("safetyblockdata5").style.display = "none";
                document.getElementById("safetyblockdata10").style.display = "block";
                document.getElementById("safetyblockdata8").style.display = "none";
                document.getElementById("safetyblockdata9").style.display = "none";
                document.getElementById("safetyblockdata11").style.display = "none";


            }
            if (data == 5) {
                document.getElementById("safetyblock5").classList.remove("lcaeBj");
                document.getElementById("safetyblock5").classList.add("bNdiGn");
                document.getElementById("safetyblock1").classList.remove("bNdiGn");
                document.getElementById("safetyblock3").classList.remove("bNdiGn");
                document.getElementById("safetyblock4").classList.remove("bNdiGn");
                document.getElementById("safetyblock2").classList.remove("bNdiGn");
                document.getElementById("safetyblockdata5").style.display = "none";
                document.getElementById("safetyblockdata9").style.display = "none";
                document.getElementById("safetyblockdata10").style.display = "none";
                document.getElementById("safetyblockdata11").style.display = "block";
                document.getElementById("safetyblockdata8").style.display = "none";
            }

        },
        showplatformdata(data) {

            if (data == 1) {
                document.getElementById("platformblock1").classList.remove("lcaeBj");
                document.getElementById("platformblock1").classList.add("bNdiGn");
                document.getElementById("platformblock2").classList.remove("bNdiGn");
                document.getElementById("platformblock3").classList.remove("bNdiGn");
                document.getElementById("platformblock4").classList.remove("bNdiGn");
                document.getElementById("platformblock5").classList.remove("bNdiGn");

                document.getElementById("platformblockdata13").style.display = "block";
                document.getElementById("platformblockdata14").style.display = "none";
                document.getElementById("platformblockdata15").style.display = "none";
                document.getElementById("platformblockdata16").style.display = "none";
                document.getElementById("platformblockdata17").style.display = "none";


            }
            if (data == 2) {
                document.getElementById("platformblock2").classList.remove("lcaeBj");
                document.getElementById("platformblock2").classList.add("bNdiGn");
                document.getElementById("platformblock1").classList.remove("bNdiGn");
                document.getElementById("platformblock3").classList.remove("bNdiGn");
                document.getElementById("platformblock4").classList.remove("bNdiGn");
                document.getElementById("platformblock5").classList.remove("bNdiGn");

                document.getElementById("platformblockdata13").style.display = "none";

                document.getElementById("platformblockdata14").style.display = "block";
                document.getElementById("platformblockdata15").style.display = "none";
                document.getElementById("platformblockdata16").style.display = "none";
                document.getElementById("platformblockdata17").style.display = "none";


            }
            if (data == 3) {
                document.getElementById("platformblock3").classList.remove("lcaeBj");
                document.getElementById("platformblock3").classList.add("bNdiGn");
                document.getElementById("platformblock2").classList.remove("bNdiGn");
                document.getElementById("platformblock1").classList.remove("bNdiGn");
                document.getElementById("platformblock4").classList.remove("bNdiGn");
                document.getElementById("platformblock5").classList.remove("bNdiGn");
                document.getElementById("platformblockdata13").style.display = "none";
                document.getElementById("platformblockdata15").style.display = "block";
                document.getElementById("platformblockdata14").style.display = "none";
                document.getElementById("platformblockdata16").style.display = "none";
                document.getElementById("platformblockdata17").style.display = "none";


            }
            if (data == 4) {

                document.getElementById("platformblock4").classList.remove("lcaeBj");
                document.getElementById("platformblock4").classList.add("bNdiGn");
                document.getElementById("platformblock1").classList.remove("bNdiGn");
                document.getElementById("platformblock3").classList.remove("bNdiGn");
                document.getElementById("platformblock2").classList.remove("bNdiGn");
                document.getElementById("platformblock5").classList.remove("bNdiGn");
                document.getElementById("platformblockdata13").style.display = "none";
                document.getElementById("platformblockdata16").style.display = "block";
                document.getElementById("platformblockdata15").style.display = "none";
                document.getElementById("platformblockdata14").style.display = "none";
                document.getElementById("platformblockdata17").style.display = "none";


            }
            if (data == 5) {

                document.getElementById("platformblock5").classList.remove("lcaeBj");
                document.getElementById("platformblock5").classList.add("bNdiGn");
                document.getElementById("platformblock1").classList.remove("bNdiGn");
                document.getElementById("platformblock3").classList.remove("bNdiGn");
                document.getElementById("platformblock4").classList.remove("bNdiGn");
                document.getElementById("platformblock2").classList.remove("bNdiGn");
                document.getElementById("platformblockdata13").style.display = "none";
                document.getElementById("platformblockdata16").style.display = "none";
                document.getElementById("platformblockdata14").style.display = "none";
                document.getElementById("platformblockdata17").style.display = "block";
                document.getElementById("platformblockdata15").style.display = "none";
            }

        },

        loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pageblocksdata = res.data.pageblocksdata;
                        this.contractcat = res.data.contractcat;
                        this.swapscat = res.data.swapscat;
                        this.contractspecdetails = res.data.contractspecdetails;
                        this.swapsrate = res.data.swapsrate;
                        this.learningcoursesen = res.data.learningcoursesen;
                        this.learningcoursesar = res.data.learningcoursesar;
                        this.currencydata = res.data.currencydata;
                        this.crossesdata = res.data.crossdata;
                        this.articlesdata = res.data.articlesdata;
                        this.marketsoffer = res.data.marketsoffers;
                        this.faqcategories=res.data.faqcategories;
                        this.faq=res.data.faq;
                        this.currentdate = res.data.currentdate;
                        this.dayname = res.data.dayname;
                        this.daynamear = res.data.daynamear;

                        if (res.data.pagedata[0].layout == 3) {
                            this.loadcontactdata();
                        }
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            document.getElementById("safetyblockdata5").style.display = "block";

            document.getElementById("safetyblockdata8").style.display = "none";

            document.getElementById("safetyblockdata9").style.display = "none";
            document.getElementById("safetyblockdata10").style.display = "none";
            document.getElementById("safetyblockdata11").style.display = "none";

        },
        loadcontactdata() {

            this.$axios.get("loadcontactdata"
            )
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.contactdata = res.data.contactdata;

                    }
                });
        }
    }
}
</script>

<style>

th {
    background-color: #005060;
    color: #ffffff;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.carousel {
    background: #2f4357;
    margin-top: 20px;
}

.carousel-item {
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}

.rtlclass {
    direction: rtl !important;
}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 10px!important;
}

tabela tr:nth-child(even) {
   background-color:none!important;
}

a:hover, a:focus {
    text-decoration: none;
    outline: none;
}
.kVMyZl ol, .kVMyZl p, .kVMyZl ul {
    font-family: Cairo,sans-serif !important;
}

#accordionswap .panel-title a::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;

}
#accordionswap .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 18px;
    font-weight: 200;
    color: #ffffff;
    text-shadow: 0px 0px 0px #fff;
    position: relative;
}
#accordionsmarket .panel-title a::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;

}
#accordionsmarket .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 18px;
    font-weight: 200;
    color: #ffffff;
    text-shadow: 0px 0px 0px #fff;
    position: relative;
}
#accordion .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}

#accordion .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordion .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}

#accordion .panel-title a:before {
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}

#accordion .panel-title a.collapsed:before {
    content: "+";
}

#accordion .panel-body {
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}

#accordion .panel-body p {
    margin-bottom: 0;
}

#analysis {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;
}
#analysis:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}
#analysiscrosses {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;

}
#analysiscrosses:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}
#analysisarticle {
    content: " ";
    width: 100%;
    position: relative;
    left: 0px;
    margin-top: -60px;
    /*background-color: #0a558c!important;*/
    background: url("https://dev.marketequityinc.com/public/public/analysis.png");
    padding: 45px 0px 0px;

}

#analysisarticle:hover {
    border-top: 0;
    border-bottom: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-style: inset;
}
#accordionfaq1 .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 0px;
}

#accordionfaq1 .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordionfaq1 .panel-title a {
    display: block;
    padding: 2px 15px 0px 2px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 0px 0px 0px #fff;
    position: relative;

}
#accordionfaq1 .panel-title a p::before {

    content: "+";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: rgb(45, 174, 202) none repeat scroll 0% 0%;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
    text-shadow: none;
    position: absolute;
    /*top: 8px;*/
    left: 2% !important;


}
@media only screen and (max-width: 450px) {
    #accordionfaq1 .panel-title a p {
        margin-bottom: 11px!important;
        /*margin-left: 57px !important;*/
        /*margin-right: 57px !important;*/
        padding-top:1%;
        padding-bottom:1%;
        padding-left:40px!important;
    }
}
#accordionfaq1 .panel-title a p {
    margin-bottom: 11px!important;
  /*margin-left: 57px !important;*/
  /*margin-right: 57px !important;*/
    padding-top:1%;
    padding-bottom:1%
}
/*#accordionfaq .panel-title a p::after {*/

/*    content: "+";*/
/*    font-family: "Font Awesome 5 Free";*/
/*    width: 25px;*/
/*    height: 25px;*/
/*    line-height: 25px;*/
/*    border-radius: 50%;*/
/*    background: rgb(45, 174, 202) none repeat scroll 0% 0%;*/
/*    font-size: 12px;*/
/*    font-weight: 900;*/
/*    color: #ffffff;*/
/*    text-align: center;*/
/*    box-shadow: inset 0 0 10px rgba(0,0,0,0.5);*/
/*    text-shadow: none;*/
/*    position: absolute;*/
/*    top: 8px;*/

/*}*/
.kVMyZl ul li::before {
    width: 24px;
    height: 16px;
}
.kVMyZl ul li::before {
    background: rgba(0, 0, 0, 0) url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVBRDA2NjA4QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVBRDA2NjA5QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUFEMDY2MDZBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUFEMDY2MDdBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/utXoAAABT0lEQVR42qzUSyhEURjA8euQlZ1iQ1ZKs7KYMnkszcpCI5mVx4LdKFlYKVYsZCNlJQsbREYpz5IsTEkWFrNSysaCpCyYpuv/1adu08ncuXNO/Tr38fV999zzqPF93wu2zoM7r5r2kIpLjkYuV3FoPMeN5C10JxjCR53j/DEcoxYJRvPocgQ9uMU7uiW5PHRVYAAXyCFJ8pe/Fy4KjOFIDZL8Lfiy2gKz2MI60vgqDTDMekpESL6MFSwgA98WJCNIYJ8ifSET12MTc5jG4n/BUmAeV9ijSGuZ5A0Sh3GMYK3c1xgm5Vv/3w929AttrQln6Fe7YYZrdHu/0g2jCxuWuHbcoA29uAw7USZwhuR0yU1gJhATxzUKkHm6r2QlmJKDaptuSQ+qpO7Oczzrb3mqdKnZziKZ9A6c6n0Wo/iMslFsBYqYRDPymNJnkdqvAAMABqdQ+HPTgMsAAAAASUVORK5CYII=") no-repeat scroll right center / contain;
    content: " ";
    position: absolute;
    width: 18px;
    height: 14px;
    top: 8px;
    right: 0px;
}
/*!sc*/
.kVMyZl {
    position: relative;
    text-align: right;
    background-size: cover;
}

/*!sc*/
.kVMyZl p {
    margin-bottom: 25px;
}

/*!sc*/
.kVMyZl ul, .kVMyZl p, .kVMyZl ol {
    font-weight: 300;
    color: #000;
    font-size: 16px;
    line-height: 2em!important;
    font-weight: 400;
}

/*!sc*/
.kVMyZl ul {
    padding: 0 0 0 5px;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl ul {
        padding: 0 0 0 20px;
    }
}

/*!sc*/
.kVMyZl li {
    list-style: none;
    position: relative;
    margin-bottom: 10px;
    padding-right: 30px;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl li {
        padding-right: 40px;
    }
}

/*!sc*/
.kVMyZl ul li:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkVBRDA2NjA4QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkVBRDA2NjA5QTkyNTExRTlCQTlCRDRBRkUyNDkxRkU3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RUFEMDY2MDZBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RUFEMDY2MDdBOTI1MTFFOUJBOUJENEFGRTI0OTFGRTciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/utXoAAABT0lEQVR42qzUSyhEURjA8euQlZ1iQ1ZKs7KYMnkszcpCI5mVx4LdKFlYKVYsZCNlJQsbREYpz5IsTEkWFrNSysaCpCyYpuv/1adu08ncuXNO/Tr38fV999zzqPF93wu2zoM7r5r2kIpLjkYuV3FoPMeN5C10JxjCR53j/DEcoxYJRvPocgQ9uMU7uiW5PHRVYAAXyCFJ8pe/Fy4KjOFIDZL8Lfiy2gKz2MI60vgqDTDMekpESL6MFSwgA98WJCNIYJ8ifSET12MTc5jG4n/BUmAeV9ijSGuZ5A0Sh3GMYK3c1xgm5Vv/3w929AttrQln6Fe7YYZrdHu/0g2jCxuWuHbcoA29uAw7USZwhuR0yU1gJhATxzUKkHm6r2QlmJKDaptuSQ+qpO7Oczzrb3mqdKnZziKZ9A6c6n0Wo/iMslFsBYqYRDPymNJnkdqvAAMABqdQ+HPTgMsAAAAASUVORK5CYII=) no-repeat;
    background-position: right center;
    background-size: contain;
    content: " ";
    position: absolute;
    width: 18px;
    height: 14px;
    top: 8px;
    right: 0;
}

/*!sc*/
@media (min-width: 768px) {
    .kVMyZl ul li:before {
        width: 24px;
        height: 16px;
    }
}

/*!sc*/
.kVMyZl ul li.cross:before {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBCQzdBNzFGRDE0NTExRTk5Qzc1QTQ1MEVEMTQ5ODMzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBCQzdBNzIwRDE0NTExRTk5Qzc1QTQ1MEVEMTQ5ODMzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEJDN0E3MUREMTQ1MTFFOTlDNzVBNDUwRUQxNDk4MzMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEJDN0E3MUVEMTQ1MTFFOTlDNzVBNDUwRUQxNDk4MzMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz66BrXQAAABZ0lEQVR42rSUvUvDQBiHNYiTm2AXoVOXTg4ZxOqoUwU/BgUHcXNy8A9xEAdHF0EyqDiVailVBwtSHDoXCqWg0NJBFzvE5+AnhJgml4IHDy9378fv7nJvJn3fn/jPMRVeWLh+3cRswPHblttjblNnFk7glpyboMOJCB7ANpQoPm9R3MSUlDMIO/8IsIMqZhEy8AT5mOJ5xWSUU00UkEgTswR9eIFCRFhBvr5im1G1nFFbQ6SDWYM6PEAx4C5qra6Yzqg6Ttzlmo+sD34n9sXv3Ph6qV5RxPiCXfiAC62dwREkvnHH8jn7EgqK+mP1QcSYhnM40K7NOIU5OITvsQXogxnMJazDDnhyvcOVGmwPPlNfEcXNDsuwKryA2wusl3UaewGK5zDPkIVlqESEVeTLKjZnJUBxF/MIQ1iBRswtNhQzVI5rc4J7aJvj0wcti0fQ0lW1lZsoUDPdSfFuir9yVx1dCzt+BBgAXR5gFqIiaRoAAAAASUVORK5CYII=) no-repeat;
    background-position: right center;
    background-size: contain;
}

/*!sc*/
.kVMyZl ol {
    list-style: decimal;
    padding-left: 20px;
}

/*!sc*/
.kVMyZl ol li {
    list-style: decimal;
    padding-left: 10px;
}

/*!sc*/
.kVMyZl h3 {
    text-transform: capitalize!important;
}
.kNCxBo{
    max-width:100%!important;

}
.ZBsdR {

    padding-left: 0px!important;
    padding-right: 0px!important;
    padding-bottom:2%!important;
}
.fHTiUO h3
{
     text-transform: capitalize!important;
}
.fHTiUO ul, .fHTiUO p, .fHTiUO ol {
}
.kcvceY h2 {

}
.JMaKG > div::before {
    background: #4dd1f0;
    content: " ";
    width: 1px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    left: 0;
    background: rgb(77, 209, 240) none repeat scroll 0% 0%;
    content: " ";
    width: 1px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
}
.JMaKG > div::after {
    background: #fff;
    content: " ";
    width: 57px;
    height: 57px;
    position: absolute;
    top: 50%;
    border-bottom: 1px solid #4dd1f0;
    border-right: 1px solid #4dd1f0;
    display: none;
    left: -28px;
    -webkit-transform: translateY(-50%) rotate(-45deg);
    -ms-transform: translateY(-50%) rotate(-45deg);
    transform: translateY(-50%) rotate(-45deg);
    background: rgb(255, 255, 255) none repeat scroll 0% 0%;
    content: " ";
    width: 57px;
    height: 57px;
    position: absolute;
    top: 50%;
    border-bottom: 1px solid rgb(77, 209, 240);
    border-right: 1px solid rgb(77, 209, 240);
    display: none;
    right: -28px;
    transform: translateY(-50%) rotate(135deg);
}
.FCFMu::before {
    content: " ";
    background: url(data:image/png;base64,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) no-repeat left center;
    background-size: auto;
    position: absolute;
    background-size: contain;
    width: 30px;
    height: 55px;
    top: 0;
    right: 0;
}
.ecLciw > div {
    width: 60%!important;

    padding-right: 5%!important;
    margin-right:1%!important;
}
.ZBsdR strong {
    font-weight: bold!important;

}
.kKgHVc .spotlight__info > div {
    text-align: left!important;
}
.kKgHVc > div p{
    font-family: Comfortaa !important;
}
.fHTiUO p {
    font-family: Comfortaa !important;
}
.fHTiUO p span {
    font-family: Comfortaa !important;
}
.fHTiUO  span {
    font-family: Comfortaa !important;
}
.cDscbW .spotlight__info p {
    text-transform:capitalize!important;

}
.kcvceY {
text-align:left!important;
}
.kcvceY h2, .lcaeBj h3 a, .lpdeLb > div h3 {
    text-transform: capitalize !important;
}
.cDscbW > figure::after {
    z-index: -1!important;
}
.ifRyix > div .thumbOverlay {
       background-color: #1a859d!imortant;
    border-radius: 50%!important;
    width: 300px!important;
    height: 300px!important;
}
.ifRyix > div::before{
    border:0px!important;
}

.ifRyix > div::after{
    border:0px!important;
}

.ifRyix > div .deposit{
 border-radius: 50%!important;
    width: 300px!important;
    height: 300px!important;
}

.ifRyix > div .thumbOverlay .btn_wrap a, .ifRyix > div .thumbOverlay .btn_wrap span{
    background: transparent!important;
}
.fHTiUO p {

    padding-left: 5%!important;
    padding-right: 5%!important;
    color: #151414!important;
}
.ifRyix > div .details_wrap {

    cursor: pointer!important;
}
.htlbQg {
    padding-top: 0px!important;
}
.fHTiUO {
    margin-bottom: -5%!important;
}
.dIoETn{
    padding-bottom:5%!important;
}
.ZBsdR strong{
    font-family: Cairo,sans-serif !important;
}

.hqzysg a span{
       font-family: inherit !important

}
.cDscbW .spotlight__info p{
           font-family: inherit !important

}
.kNCxBo{
        background-image: url(https://devbackup.marketequityinc.com/public/public/129/20210614094716aboutusbg.png)!important;

}
.kNCxBo div{
    font-family: Cairo,sans-serif !important;
}
.iQutzW {

    padding-top: 0px!important;
    padding-bottom: 0px!important;
    background: #fff!important;
}
.responsive-image {
    position: absolute!important;
    top: 0!important;
    left: 0!important;
    opacity: 1!important;
    width: 100%!important;
    height: 100%!important; /* Set a default height */
    object-fit: cover!important;
    object-position: center center!important;

}
.kKgHVc .gatsby-image-wrapper {
    height: 100vh!important;
}
@media (max-width: 768px) {
    .responsive-image {
        height: 65vh!important; /* 65% of the viewport height */
        top:15%!important;
    }

    .cDscbW > figure::before {
        content: " ";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 65%;
        z-index: 1;
    }
    .kKgHVc .gatsby-image-wrapper {
        height: 65vh!important;
    }
    .kKgHVc {
        position: relative;
        height: 65vh!important;
    }
    .jQPPQ {

        top: 2%!important;
    }
    .iMlrcz {

        left: -3% !important;
        right: -3% !important;

    }
}
.efXZNd p {

    line-height: 40px !important;

}

</style>
